import { DATE_FORMAT, DATE_TIME_FORMAT, DECIMAL_LIMIT } from "../constants"
import moment from "moment"
import _ from "lodash"

import Fuse from 'fuse.js';
import { useCallback } from "react";
import { v4 as uuidv4 } from 'uuid';
import { fileTypeFromBlob, fileTypeFromStream } from 'file-type';

export const PAN_REGEX_FORMAT = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const GSTIN_REGEX_FORMAT = /[0-9]{2}[A-Z]{4}[0-9A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z]{1}[0-9A-Z]{1}$/
export const EMAIL_REGEX_FORMAT =  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]/ //  /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/

export const round = (value, decimal_limit) => {
    if(!decimal_limit && decimal_limit != 0){
        decimal_limit = DECIMAL_LIMIT
    }
    return parseFloat(parseFloat(value).toFixed(decimal_limit))
}

export const replaceStr = (str, char, replacer) => {
    const regex = new RegExp(char, "g")
    const replaced = str.replace(regex, replacer)
    return replaced
}

export const getDateString = (dateObj, strFormat, timeZone) => {
    let date_string_format = strFormat ? strFormat : DATE_FORMAT
    return moment(dateObj).format(date_string_format)
}

export const getDateTimeString = (dateObj, strFormat, timeZone) => {
    let date_string_format = strFormat ? strFormat : DATE_TIME_FORMAT
    return moment(dateObj).format(date_string_format)
}

export const compareDates = (dateStr1, dateStr2) => {
    // Split the date strings into day, month, and year
    const [day1, month1, year1] = dateStr1.split('.').map(Number);
    const [day2, month2, year2] = dateStr2.split('.').map(Number);

    // Create Date objects
    const date1 = new Date(year1, month1 - 1, day1); // month is 0-based in Date constructor
    const date2 = new Date(year2, month2 - 1, day2);

    // Compare dates
    if (date1 < date2) {
        return true
    } else if (date1 >= date2) {
        return false
    }
}

export const normalizeLabel = (label) => {
    return label.replace(/(_|-)/g, ' ')
        .trim()
        .replace(/\w\S*/g, function(str) {
            return str.charAt(0).toUpperCase() + str.substr(1)
        })
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
}

export const addDaysToDate = (date, days) => {
    let newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate
}

export const isValidNumber = (str) => {
    const regex = /^-?\d*\.?\d+$/;
    return regex.test(str)
}

export const getDaysDifference = (startDate, endDate) => {
    var startMoment = moment(startDate)
    var endMoment = moment(endDate)
  
    var duration = moment.duration(endMoment.diff(startMoment))
    var days = duration.asDays()
  
    return days
}

export const getTimeDifference = (startDate, endDate) => {
    let startMoment = new Date(startDate)
    let endMoment = new Date(endDate)
    const timeDifference = endMoment.getTime() - startMoment.getTime();

    // Convert milliseconds to hours
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference
}

export const numberConversion = (number, numberLocale) => {
    if (!numberLocale){
        numberLocale = "en-IN"
    }
    return number?.toLocaleString(numberLocale)
}

export const numberToWords = (amount) => {
    const indianRupee = "Rupees";
    const indianPaise = "Paise";
    const units = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    function convertTwoDigits(n) {
        if (n < 10) {
            return units[n];
        } else if (n < 20) {
            return teens[n - 10];
        } else {
            const digit = n % 10;
            const ten = Math.floor(n / 10);
            return tens[ten] + (digit ? " " + units[digit] : "");
        }
    }

    function convertThreeDigits(n) {
        const hundred = Math.floor(n / 100);
        const remainder = n % 100;

        if (hundred && remainder) {
            return units[hundred] + " Hundred " + convertTwoDigits(remainder);
        } else if (hundred) {
            return units[hundred] + " Hundred";
        } else {
            return convertTwoDigits(remainder);
        }
    }

    function convertNumber(number) {
        if (number === 0) {
            return "Zero";
        }

        const crore = Math.floor(number / 10000000);
        const remainder = number % 10000000;

        let result = "";

        if (crore) {
            result += convertThreeDigits(crore) + " Crore ";
        }

        const lakh = Math.floor(remainder / 100000);
        const remainingThousands = remainder % 100000;

        if (lakh) {
            result += convertThreeDigits(lakh) + " Lakh ";
        }

        const thousand = Math.floor(remainingThousands / 1000);
        const remainingHundreds = remainingThousands % 1000;

        if (thousand) {
            result += convertThreeDigits(thousand) + " Thousand ";
        }

        if (remainingHundreds) {
            result += convertThreeDigits(remainingHundreds);
        }

        return result.trim();
    }

    return `${convertNumber(Math.floor(amount))} ${indianRupee} and ${convertTwoDigits(Math.round((amount % 1) * 100))} ${indianPaise}`;

}

export const getFullName = (firstName, lastName, companyRoleName) => {
    let companyInitials = ""
    if(companyRoleName){
        companyInitials = companyRoleName.split(' ').map(word => word[0]).join('').toUpperCase()
        companyInitials = '(' + companyInitials + ')'
    }
    return `${firstName ? firstName : ''} ${lastName ? lastName : ''} ${companyInitials}`
}

export const getProductQty = (qty, uom, uomValue) => {
    // return `${uomValue ? uomValue : '1'} ${uom ? uom : 'NOS'} * ${qty}`
    return qty
}

export const getUOMStr = (uom, uomValue) => {
    return `${uomValue ? uomValue : '1'} ${uom ? uom : 'NOS'}`
}

export const getProductName = (brandName, productName, variantName) => {
    return `${brandName ? `${brandName} -` : ''} ${productName} ${variantName && !['NA', 'NA.'].includes(variantName) ? `- ${variantName}` : ''}`
}

export const getProductSpecification = (productSpecification, uom, uomValue) => {
    return `${productSpecification} - ${uomValue ? uomValue : '1'} ${uom ? uom : 'NOS'}`
}

export const getBuyerProductName = (companyProdName, productName) => {
    return companyProdName ? companyProdName : productName
}

export const getBuyerProductSpecification = (companyProdSpec, productSpecification, uom, uomValue) => {
    const spec = companyProdSpec ? companyProdSpec : productSpecification
    return `${spec} - ${uomValue ? uomValue : '1'} ${uom ? uom : 'NOS'}`
}

export const getDuplicatesInArray = (array, keys) => {
    const grouped = _.groupBy(array, obj => keys.map(key => obj[key]).join('|'));
    return _.flatMap(grouped, group => group.length > 1 ? group : []);
}

export const getMobileNumber = (mobileNum) => {
    let updatedPhoneNum = mobileNum
    if (mobileNum?.toString().length > 10){
        let mobileNumStr = mobileNum.toString()
        let phnNumLen = mobileNumStr.length
        let requiredLen = phnNumLen - 10
        updatedPhoneNum = mobileNumStr.slice(requiredLen,)
    }
    return parseInt(updatedPhoneNum)
}

export const getPMUserNameByUserId = (pmCompanyUsers, userId) => {
    const userDetails = pmCompanyUsers.find(eachUser => eachUser.userId === userId)
    const userFullName = getFullName(userDetails?.firstName, userDetails?.lastName)

    return userFullName
}

export const getPaymentTermsString = (paymentTerms, companyCreditPeriods) => {
    if (paymentTerms) {
        const paymentTermsStringArr = []
        const paymentTermsArr = Object.keys(paymentTerms ? paymentTerms : [])

        paymentTermsArr.map(eachPaymentTerm => {
            const creditPeriod = companyCreditPeriods?.find(eachCP => eachCP.creditPeriodId === paymentTerms.creditPeriodId)?.creditPeriodName

            if (eachPaymentTerm === 'payAdvDelivery') {
                let paymentTermText = paymentTerms[eachPaymentTerm] === 100 ? "Advance before delivery \n" : "Advance before delivery : " + paymentTerms[eachPaymentTerm] + "%\n"
                paymentTerms[eachPaymentTerm] > 0 && paymentTermsStringArr.push(paymentTermText)
            }
            if (eachPaymentTerm === 'payAdvPO') {
                let paymentTermText = paymentTerms[eachPaymentTerm] === 100 ? "Advance against PO \n" : "Advance against PO : " + paymentTerms[eachPaymentTerm] + "%\n"
                paymentTerms[eachPaymentTerm] > 0 && paymentTermsStringArr.push(paymentTermText)
            }
            if (eachPaymentTerm === 'payPDCDelivery') {
                let creditText = paymentTerms[eachPaymentTerm] === 100 ? "PDC on Delivery " : "PDC on Delivery : " + paymentTerms[eachPaymentTerm] + "% "
                if (paymentTerms.creditPeriodId) {
                    creditText += "(" + creditPeriod + ")\n"
                }
                paymentTerms[eachPaymentTerm] > 0 && paymentTermsStringArr.push(creditText)
            }
            if (eachPaymentTerm === 'payOnDelivery') {
                let paymentTermText = paymentTerms[eachPaymentTerm] === 100 ? "Payment against delivery \n" : "Payment against delivery : " + paymentTerms[eachPaymentTerm] + "%\n"
                paymentTerms[eachPaymentTerm] > 0 && paymentTermsStringArr.push(paymentTermText)
            }
            if (eachPaymentTerm === 'payCredit') {
                let creditText = paymentTerms[eachPaymentTerm] === 100 ? "Credit " : "Credit : " + paymentTerms[eachPaymentTerm] + "% "
                if (paymentTerms.creditPeriodId) {
                    creditText += "(" + creditPeriod + ")"
                }
                paymentTerms[eachPaymentTerm] > 0 && paymentTermsStringArr.push(creditText)
            }
        })
        const paymentTermsString = paymentTermsStringArr.join("")
        
        return {
            paymentTermsString, 
            paymentTermsStringArr
        }
    }
}

export const getMaterialMasterDetailsTooltip = (materialDetails) => {
    const { productName, productSpecification, variantName, brandName, categoryName, renderHTML, UOMValue, UOM} = materialDetails

    let displayProdNameArr = []
    if(brandName){
        displayProdNameArr.push(brandName)
    }
    if(productName){
        displayProdNameArr.push(productName)
    }
    if(variantName){
        displayProdNameArr.push(variantName)
    }

    const displayProdName = displayProdNameArr.join(" - ")

    if(renderHTML){
        return (
            <div>
                <p className="m-0">{`${displayProdName} | ${productSpecification} ${UOM ? `| ${UOMValue ? UOMValue : '1'} * ${UOM}` : ''}`}</p>
                { categoryName ? <p className="m-0">{`category: ${categoryName}`}</p> : "" }
            </div>
        )
    } else {
        return `${displayProdName} | ${productSpecification} ${UOM ? `| ${UOMValue ? UOMValue : '1'} * ${UOM}` : ''} ${categoryName ? `\n Category: ` + categoryName : ""}`
    }
}

export const checkPermissions = (data) => {
    const userCompanyRoleIds = data.userCompanyRoleIds || [data.activeCompanyRoleId]
    //const reqPermActionIds = data.reqPermActionIds || data.permissions ? data.reqPermActionIds || data.permissions : []
    let reqPermActionIds = []
    if(data.reqPermActionIds?.length > 0){
        reqPermActionIds = data.reqPermActionIds
    } else if(data.permissions?.length > 0) {
        reqPermActionIds = data.permissions
    }
    
    const permActions = data.permActions ? data.permActions : []
    const permRoles = data.permRoles ? data.permRoles : []
    //const permGeo = data.permGeo ? data.permGeo : []
    const permExceptions = data.permExceptions ? data.permExceptions : []

    const relatedPermActions = permActions.filter(eachAction => reqPermActionIds.includes(eachAction.permActionId))

    let permittedCompanyRoleIds = [] 
    let permittedExceptionUserRoleIds = []
    let permittedExceptionNegitiveUserRoleIds = []

    const permittedActions = relatedPermActions.filter(eachPermAction => {
        const permittedRoles = permRoles.filter(eachPermRole => eachPermRole.permActionId === eachPermAction.permActionId).map(eachPermRole => eachPermRole.companyRoleId)
        const perittedExceptionUserRoles = permExceptions.filter(eachPermException => eachPermException.permActionId === eachPermAction.permActionId && eachPermException.permExceptionGrant).map(eachPermException => eachPermException.userRoleId)
        const perittedExceptionNegitiveUserRoles = permExceptions.filter(eachPermException => eachPermException.permActionId === eachPermAction.permActionId && !eachPermException.permExceptionGrant).map(eachPermException => eachPermException.userRoleId)

        const relatedPermRole = permRoles.find(eachPermRole => eachPermRole.permActionId === eachPermAction.permActionId && userCompanyRoleIds.includes(eachPermRole.companyRoleId))
        const relatedPermException = permExceptions.find(eachPermException => eachPermException.userRoleId === data.userRoleId && eachPermException.permActionId === eachPermAction.permActionId)
        //const relatedPermGeo = permGeo.find(eachPermGeo => eachPermGeo.userRoleId === userDetails.userRoleId)

        let isPermitted = false
        if(relatedPermRole){
            if(relatedPermRole.param1_title === "AMT_UPPER_LIMIT" && data.permParameters?.amount){
                if(parseInt(relatedPermRole.param1) >= data.permParameters?.amount){
                    isPermitted = true
                } else {
                    isPermitted = false
                }
            } else {
                isPermitted = true
            }
        }
        if(relatedPermException){
            if(relatedPermException.permExceptionGrant){
                if(relatedPermException.param1_title === "AMT_UPPER_LIMIT" && data.permParameters?.amount){
                    if(parseInt(relatedPermException.param1) >= data.permParameters?.amount){
                        isPermitted = true
                    } else {
                        isPermitted = false
                    }
                } else {
                    isPermitted = true
                }
            } else {
                isPermitted = false
            }
        }

        if(permittedRoles.length){
            permittedCompanyRoleIds.push(permittedRoles)
        }
        if(perittedExceptionUserRoles.length){
            permittedExceptionUserRoleIds.push(perittedExceptionUserRoles)
        }
        if(perittedExceptionNegitiveUserRoles.length){
            permittedExceptionNegitiveUserRoleIds.push(perittedExceptionNegitiveUserRoles)
        }
        return isPermitted
    })

    let isPermitted = false

    if (data.activeCompanyRoleId){
        if(relatedPermActions.length === permittedActions.length){
            isPermitted = true
        } else {
            isPermitted = false
        }
    } 

    permittedCompanyRoleIds = _.intersection(...permittedCompanyRoleIds)
    permittedExceptionUserRoleIds = _.intersection(...permittedExceptionUserRoleIds)
    permittedExceptionNegitiveUserRoleIds = _.intersection(...permittedExceptionNegitiveUserRoleIds)

    let permissionsResultMap = {}
    if (data.userCompanyRoleIds){
        reqPermActionIds.map(eachPermActionId => {
            const relatedPermittedAction = permittedActions.find(eachPermittedAction => eachPermittedAction.permActionId === eachPermActionId)
            if (relatedPermittedAction){
                permissionsResultMap[eachPermActionId] = true
            }else{
                permissionsResultMap[eachPermActionId] = false
            }
        })
    }

    return {
        isPermitted,
        permissionsResultMap,
        permActionIds: reqPermActionIds,
        permittedCompanyRoleIds: permittedCompanyRoleIds, 
        permittedExceptionUserRoleIds: permittedExceptionUserRoleIds,
        permittedExceptionNegitiveUserRoleIds: permittedExceptionNegitiveUserRoleIds
    }
}

export const calculateQuoteApprovals = (data) => {

    let { buyerReq, buyerReqItems, quotationApprovals, buyerQuote, buyerQuoteItems, updatedByUserDetails } = data
    buyerQuoteItems = JSON.parse(JSON.stringify(buyerQuoteItems))

    if(buyerReq && buyerReq.orderTypeId === 2){
        return []
    }

    const activeBuyerReqItems = buyerReqItems.filter(eachReqItem => eachReqItem.statusId !== 2)
    let updatedRequiredApprovals = []

    let totalItemBuyerUnitPrices = 0
    let totalItemMarginAmounts = 0

    buyerReqItems.map(eachBuyerReqItem => {
        const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId)
        const weightedSum = _.sumBy(relatedBuyerQuoteItems, eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerPrice * parseFloat(eachBuyerQuoteItem.bQuotSellerQty) || 0)
        const totalQuantity = _.sumBy(relatedBuyerQuoteItems, eachBuyerQuoteItem => parseFloat(eachBuyerQuoteItem.bQuotSellerQty) || 0)
        const weightedAverageSellerPrice = round(weightedSum / totalQuantity, 2)

        const buyerUnitPrice = relatedBuyerQuoteItems[0]?.bQuotUnitPrice

        const avgSellerPrice = weightedAverageSellerPrice
        const marginAmount = buyerUnitPrice - avgSellerPrice

        totalItemBuyerUnitPrices += buyerUnitPrice
        totalItemMarginAmounts += marginAmount
    })

    const marginPercent = round((totalItemMarginAmounts / totalItemBuyerUnitPrices) * 100, 2)

    const isMoreSuggMarginApplied = buyerQuoteItems.some(eachBuyerQuoteItem => {
        if (eachBuyerQuoteItem.suggMargin){
            const itemSuggestedMargin = eachBuyerQuoteItem.suggMargin || 0
            if (eachBuyerQuoteItem.bQuotMarginRate >= itemSuggestedMargin){
                return true
            }
            return false
        }
        return true
    })

    const skipApprovalTypeIds = []

    quotationApprovals.map(eachApproval => {
        if (marginPercent > 7.5 && buyerQuote.bQuotTotalItemAmountWithTax < 500000 && isMoreSuggMarginApplied){
            if (![2].includes(eachApproval.approvalTypeId)){
                skipApprovalTypeIds.push(eachApproval.approvalTypeId)
            }
        }
    })

    quotationApprovals.map(eachApproval => {
        if (eachApproval.approvalTypeId === 1 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {  // >1Lac  
            
            const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)

            if (lowerLimit <= buyerQuote.bQuotTotalItemAmountWithTax && buyerQuote.bQuotTotalItemAmountWithTax < upperLimit) {
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                    statusId: 12,
                    remarks: ''
                })
            }
        }
        else if (eachApproval.approvalTypeId === 2 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) { //loss
            let totalLoss = 0
            activeBuyerReqItems.forEach(eachReqItem => {
                const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                const sellerReqItemIds = []

                let totalSellersPrice = 0
                relatedBuyerQuoteItems?.forEach(eachBuyerQuoteItem => {  //confirm this once!
                    let beforeTax = 0
                    let totalTax = 0
                    let totalPrice = 0

                    if (eachBuyerQuoteItem.bQuotSellerQty && !sellerReqItemIds.includes(eachBuyerQuoteItem.sellerReqItemId)) {
                        let bQuotSellerQuantity = round(eachBuyerQuoteItem.bQuotSellerQty)
                        beforeTax = round(bQuotSellerQuantity * eachBuyerQuoteItem.bQuotSellerPrice)
                        totalPrice = beforeTax
                        totalTax = 0

                        if (eachBuyerQuoteItem.bQuotSellerGSTRate) {
                            totalTax = round(eachBuyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
                            totalPrice = totalTax + beforeTax
                        }
                        sellerReqItemIds.push(eachBuyerQuoteItem.sellerReqItemId)
                    }
                    
                    totalSellersPrice += totalPrice
                })

                let loss = 0
                if (relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax) {
                    loss = round(parseFloat(relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax) - totalSellersPrice)
                }
                totalLoss += loss
            })
            totalLoss = round(totalLoss)

            if (totalLoss < 0) {

                const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)

                if (lowerLimit <= Math.abs(totalLoss) && Math.abs(totalLoss) < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: totalLoss },
                        statusId: 12,
                        isRequired: false,
                        remarks: ''
                    })
                }
            }
        }
        else if (eachApproval.approvalTypeId === 3 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {  // brand 

            let isBrandApprovalRequired = false
            let totalBrandAmount = 0

            const { brand_id, upperLimit, lowerLimit } = getApprovalParams(eachApproval)

            activeBuyerReqItems.forEach(eachReqItem => {
                if (eachReqItem.brandId === brand_id) {
                    const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1 && eachBuyerQuoteItem.bQuoteItemAmountWithTax)

                    if (relatedBuyerQuoteItems.length > 0) {
                        isBrandApprovalRequired = true
                        totalBrandAmount += relatedBuyerQuoteItems[0].bQuoteItemAmountWithTax
                    }
                }
            })

            if (isBrandApprovalRequired) {

                if (lowerLimit <= totalBrandAmount && totalBrandAmount < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: totalBrandAmount },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }
        }
        else if (eachApproval.approvalTypeId === 4 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {  // category 
            let isCategoryApprovalRequired = false
            let totalCategoryAmount = 0

            const { category_ids, upperLimit, lowerLimit } = getApprovalParams(eachApproval)

            activeBuyerReqItems.forEach(eachReqItem => {
                if (category_ids.includes(eachReqItem.categoryId)) {
                    const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId && eachBuyerQuoteItem.bQuoteItemAmountWithTax && eachBuyerQuoteItem.statusId === 1)
                    if (relatedBuyerQuoteItems.length > 0) {
                        isCategoryApprovalRequired = true
                        totalCategoryAmount += relatedBuyerQuoteItems[0].bQuoteItemAmountWithTax
                    }
                }
            })

            if (isCategoryApprovalRequired) {

                if (lowerLimit <= totalCategoryAmount && totalCategoryAmount < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: totalCategoryAmount },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }
        }
        else if (eachApproval.approvalTypeId === 5 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {  
            activeBuyerReqItems.forEach(eachReqItem => { 
                const relatedBuyerQuoteItem = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                if (relatedBuyerQuoteItem?.bestAvgSellerPrice !== relatedBuyerQuoteItem?.avgSellerPrice) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: relatedBuyerQuoteItem.avgSellerPrice },
                        materialId: eachReqItem.materialId,
                        statusId: 12,
                        remarks: ''
                    })
                }
            })
        }
        else if (eachApproval.approvalTypeId === 6 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {
            if (buyerQuote.bQuotLogisticsBeforeTax && (buyerQuote.bQuotLogisticsGSTRate || buyerQuote.bQuotLogisticsGSTRate === 0) && buyerQuote.bQuotLogisticsGSTRate !== buyerQuote.maxLogisticGSTRate) {
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerQuote.bQuotLogisticsGSTRate },
                    statusId: 12,
                    remarks: ''
                })
            }
        }
        else if (eachApproval.approvalTypeId === 10 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)) {
            if (buyerReq && buyerReq.reqTagId === 1) {
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                    statusId: 12,
                    remarks: ''
                })
            }
        }
        else if (eachApproval.approvalTypeId === 28 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)){
            if (buyerReq && buyerReq.isRouted && eachApproval.param4.includes(buyerReq.companyId)){
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                    statusId: 12,
                    remarks: ''
                })
            }
        } 
        else if (eachApproval.approvalTypeId === 39 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)){
            const {upperLimit, lowerLimit, category_ids, pmBranchIds} = getApprovalParams(eachApproval)

            if (lowerLimit <= Math.abs(buyerQuote.bQuotTotalItemAmountWithTax) && Math.abs(buyerQuote.bQuotTotalItemAmountWithTax) < upperLimit) {
                let isCategoryApprovalRequired = false
                activeBuyerReqItems.forEach(eachReqItem => {
                    if (category_ids.includes(eachReqItem.categoryId)){
                        const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId && eachBuyerQuoteItem.bQuoteItemAmountWithTax && eachBuyerQuoteItem.statusId === 1)
                        if (relatedBuyerQuoteItems.length > 0) {
                            isCategoryApprovalRequired = true
                        }
                    }
                })
                if (isCategoryApprovalRequired){
                    const requiredApprovalIds = updatedRequiredApprovals.map(eachRequiredApproval => eachRequiredApproval.approvalId)
                    const currentApprovalTypeRelatedApprovalIds = quotationApprovals.filter(eachQuoteApproval => eachQuoteApproval.approvalTypeId === eachApproval.approvalTypeId).map(eachQuoteApproval => eachQuoteApproval.approvalId)
        
                    if (pmBranchIds && pmBranchIds.length){
                        if (pmBranchIds.includes(buyerQuote.pmBranchId)){
                            updatedRequiredApprovals = updatedRequiredApprovals.filter(eachRequiredApproval => {
                                if (!currentApprovalTypeRelatedApprovalIds.includes(eachRequiredApproval.approvalId)){
                                    return eachRequiredApproval
                                }
                            })
                            updatedRequiredApprovals.push({
                                approvalId: eachApproval.approvalId,
                                approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                                statusId: 12,
                                isRequired: false,
                                remarks: ''
                            })
                        }
                    }else {
                        const isCurrentApprovalTypeRelatedApprovalExists = currentApprovalTypeRelatedApprovalIds.some(eachApprovalId => requiredApprovalIds.includes(eachApprovalId))
                        if (!isCurrentApprovalTypeRelatedApprovalExists){
                            updatedRequiredApprovals.push({
                                approvalId: eachApproval.approvalId,
                                approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                                statusId: 12,
                                isRequired: false,
                                remarks: ''
                            })
                        }
                    }
                }
            }
        }
        else if (eachApproval.approvalTypeId === 38 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)){
            let updatedByUserBranchRelatedRole = {}
            if (updatedByUserDetails){
                updatedByUserBranchRelatedRole = updatedByUserDetails.userRoles?.find(eachUserRole => eachUserRole.branchId === buyerQuote.pmBranchId && eachUserRole.statusId === 1)
            }
            if (updatedByUserBranchRelatedRole && eachApproval.param4.includes(updatedByUserBranchRelatedRole.companyRoleId)){
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerQuote.bQuotTotalItemAmountWithTax },
                    statusId: 12,
                    remarks: ''
                })
            }
        }
        else if (eachApproval.approvalTypeId === 40 && !skipApprovalTypeIds.includes(eachApproval.approvalTypeId)){
            const {upperLimit, lowerLimit, category_ids, pmBranchIds} = getApprovalParams(eachApproval)

            let totalLoss = 0
            activeBuyerReqItems.forEach(eachReqItem => {
                const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)

                let totalSellersPrice = 0
                relatedBuyerQuoteItems?.forEach(eachBuyerQuoteItem => {  //confirm this once!
                    let beforeTax = 0
                    let totalTax = 0
                    let totalPrice = 0

                    if (eachBuyerQuoteItem.bQuotSellerQty) {
                        let bQuotSellerQuantity = round(eachBuyerQuoteItem.bQuotSellerQty)
                        beforeTax = round(bQuotSellerQuantity * eachBuyerQuoteItem.bQuotSellerPrice)
                        totalPrice = beforeTax
                        totalTax = 0

                        if (eachBuyerQuoteItem.bQuotSellerGSTRate) {
                            totalTax = round(eachBuyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
                            totalPrice = totalTax + beforeTax
                        }
                    }
                    totalSellersPrice += totalPrice
                })

                let loss = 0
                if (relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax) {
                    loss = round(parseFloat(relatedBuyerQuoteItems?.[0]?.bQuoteItemAmountWithTax) - totalSellersPrice)
                }
                totalLoss += loss
            })
            totalLoss = round(totalLoss)

            let isCategoryApprovalRequired = false
            activeBuyerReqItems.forEach(eachReqItem => {
                if (category_ids.includes(eachReqItem.categoryId)){
                    const relatedBuyerQuoteItems = buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId && eachBuyerQuoteItem.bQuoteItemAmountWithTax && eachBuyerQuoteItem.statusId === 1)
                    if (relatedBuyerQuoteItems.length > 0) {
                        isCategoryApprovalRequired = true
                    }
                }
            })

            if (totalLoss < 0 && isCategoryApprovalRequired){
                if (lowerLimit <= Math.abs(totalLoss) && Math.abs(totalLoss) < upperLimit) {
                    const requiredApprovalIds = updatedRequiredApprovals.map(eachRequiredApproval => eachRequiredApproval.approvalId)
                    const currentApprovalTypeRelatedApprovalIds = quotationApprovals.filter(eachQuoteApproval => eachQuoteApproval.approvalTypeId === eachApproval.approvalTypeId).map(eachQuoteApproval => eachQuoteApproval.approvalId)

                    if (pmBranchIds && pmBranchIds.length){
                        if (pmBranchIds.includes(buyerQuote.pmBranchId)){
                            updatedRequiredApprovals = updatedRequiredApprovals.filter(eachRequiredApproval => {
                                if (!currentApprovalTypeRelatedApprovalIds.includes(eachRequiredApproval.approvalId)){
                                    return eachRequiredApproval
                                }
                            })
                            updatedRequiredApprovals.push({
                                approvalId: eachApproval.approvalId,
                                approvedMetrics: { amount: totalLoss },
                                statusId: 12,
                                isRequired: false,
                                remarks: ''
                            })
                        }
                    }else {
                        const isCurrentApprovalTypeRelatedApprovalExists = currentApprovalTypeRelatedApprovalIds.some(eachApprovalId => requiredApprovalIds.includes(eachApprovalId))

                        if (!isCurrentApprovalTypeRelatedApprovalExists){
                            updatedRequiredApprovals.push({
                                approvalId: eachApproval.approvalId,
                                approvedMetrics: { amount: totalLoss },
                                statusId: 12,
                                isRequired: false,
                                remarks: ''
                            })
                        }
                    }
                }
            }
        }
    })
    return updatedRequiredApprovals
}

export const getApproverDetails = (approval, pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary) => {
    const relatedBranch = pmBranches.find(eachBranch => eachBranch.branchId === pmBranchId)
    const relatedApprovalSecondary = approvalSecondary.filter(eachApprovalSecondary => eachApprovalSecondary.approvalId === approval.approvalId)

    let allApprovers = []
    
    /*if(relatedBranch && ['X'].includes(relatedBranch.branchType)){
        pmCompanyUsers.map(eachCompanyUser => {
            if(eachCompanyUser.statusId === 1){
                eachCompanyUser.userRoles.map(eachUserRole => {
                    const relatedCompanyRole = pmCompanyRoles.find(eachRole => eachRole.companyRoleId === eachUserRole.companyRoleId)
                    if(pmBranchId && eachUserRole.branchId === pmBranchId && [3, 13].includes(eachUserRole.companyRoleId) && eachUserRole.statusId === 1){
                        let approver = {...eachCompanyUser}
                        approver.fullName = getFullName(approver?.firstName, approver?.lastName, relatedCompanyRole?.companyRoleName)
                        allApprovers.push(approver)
                    }
                })
            }
        })
    }*/

    if(relatedBranch && [3].includes(relatedBranch.branchId)){
        pmCompanyUsers.map(eachCompanyUser => {
            if(eachCompanyUser.statusId === 1){
                eachCompanyUser.userRoles.map(eachUserRole => {
                    const relatedCompanyRole = pmCompanyRoles.find(eachRole => eachRole.companyRoleId === eachUserRole.companyRoleId)
                    if(pmBranchId && eachUserRole.branchId === pmBranchId && [3, 13].includes(eachUserRole.companyRoleId) && eachUserRole.statusId === 1){
                        let approver = {...eachCompanyUser}
                        approver.fullName = getFullName(approver?.firstName, approver?.lastName, relatedCompanyRole?.companyRoleName)
                        allApprovers.push(approver)
                    }
                })
            }
        })
    } else {
        if(approval.approvalRole === "USER"){
            let approver = pmCompanyUsers.find(eachUser => eachUser.userId === approval.primaryApprover)
            approver = {...approver}
            approver.fullName = getFullName(approver?.firstName, approver?.lastName)
            allApprovers.push(approver)
        }
        else if(approval.approvalRole === "COMPANY ROLE"){
            const primaryApproverRoleId = approval.primaryApprover
            const relatedCompanyRole = pmCompanyRoles.find(eachRole => eachRole.companyRoleId === primaryApproverRoleId)

            pmCompanyUsers.map(eachCompanyUser => {
                if(eachCompanyUser.statusId === 1){
                    eachCompanyUser.userRoles.map(eachUserRole => {
                        if(pmBranchId && eachUserRole.branchId === pmBranchId && eachUserRole.companyRoleId === primaryApproverRoleId && eachUserRole.statusId === 1){
                            let approver = {...eachCompanyUser}
                            approver.fullName = getFullName(approver?.firstName, approver?.lastName, relatedCompanyRole?.companyRoleName)
                            allApprovers.push(approver)
                        } else if(!pmBranchId && eachUserRole.companyRoleId === primaryApproverRoleId && eachUserRole.statusId === 1){
                            let approver = {...eachCompanyUser}
                            approver.fullName = getFullName(approver?.firstName, approver?.lastName, relatedCompanyRole?.companyRoleName)
                            allApprovers.push(approver)
                        }
                    })
                }
            })
        }
    }

    const updatedAllApprovers = []
    allApprovers.map(eachApprover => {
        if(eachApprover.userId === createdBy){
            let relatedManager = null
            pmCompanyUsers.map(eachCompanyUser => {
                if(eachCompanyUser.statusId === 1){
                    eachCompanyUser.userRoles.map(eachUserRole => {
                        const relatedCompanyRole = pmCompanyRoles.find(eachRole => eachRole.companyRoleId === eachUserRole.companyRoleId)
                        if(pmBranchId && eachUserRole.branchId === pmBranchId && createdBy === eachUserRole.managerId && eachUserRole.statusId === 1){
                            let approver = {...eachCompanyUser}
                            approver.fullName = getFullName(approver?.firstName, approver?.lastName, relatedCompanyRole?.companyRoleName)
                            relatedManager = approver
                        }
                    })
                }
            })
            if(relatedManager){
                updatedAllApprovers.push(relatedManager) 
            }
        } else {
            updatedAllApprovers.push(eachApprover) 
        }
    })

    const allApproverUserIds = allApprovers.map(eachApprover => eachApprover.userId)
    const approvalSecondaryUsers = []

    relatedApprovalSecondary.map(eachApprovalSecondary => {
        if(allApproverUserIds.includes(eachApprovalSecondary.secondaryUserId)){
            let relatedSecondaryUser = pmCompanyUsers.find(eachUser => eachUser.userId === eachApprovalSecondary.secondaryUserId)
            if(relatedSecondaryUser){
                relatedSecondaryUser = {...relatedSecondaryUser}
                relatedSecondaryUser.fullName = getFullName(relatedSecondaryUser?.firstName, relatedSecondaryUser?.lastName) + "*"
                approvalSecondaryUsers.push(relatedSecondaryUser)
            }
        }
    })

    return [...allApprovers, ...approvalSecondaryUsers]
}

export const getBuyerPOApprovals = (data) => {
    const { POApprovals, buyerReq, buyerPO } = data
    const updatedRequiredApprovals = []
    POApprovals.map(eachApproval => {
        if (eachApproval.approvalTypeId === 14) {  

            if (buyerReq && buyerReq.orderTypeId === 3) {
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    statusId: 12,
                    remarks: ''
                })
            }
        } else if (eachApproval.approvalTypeId === 22){
            if (buyerReq && buyerReq.isRouted && eachApproval.param4.includes(buyerReq.companyId)){
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    statusId: 12,
                    remarks: ''
                })
            }
        } else if (eachApproval.approvalTypeId === 26){
            if (buyerReq && eachApproval.companyId === buyerReq.companyId){
                updatedRequiredApprovals.push({
                    approvalId: eachApproval.approvalId,
                    approvedMetrics: { amount: buyerPO.totalPOAmount },
                    statusId: 12,
                    remarks: ''
                })
            }
        }else if (eachApproval.approvalTypeId === 30) {  
            if (buyerReq && buyerReq.isBuyerCreated && eachApproval.param4.includes(buyerReq.companyId)){
                const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)

                if (lowerLimit <= parseFloat(buyerPO.totalPOAmount) && parseFloat(buyerPO.totalPOAmount) < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: buyerPO.totalPOAmount },
                        statusId: 12,
                        remarks: ''
                    })
                }
            }
        }
    })

    return updatedRequiredApprovals
}

export const getSellerPOApprovals = (data) => {
    const { POApprovals, sellerPO, sellerPOItems, sellerCompanyDetails, sellerReqs, sellerReqItems, buyerQuoteItems, companyCreditPeriods, sellerPIPunch, totalAmtFlag, materialMasterData, nonRoutedSellerPOsInfo, materialMandatoryUseFromStock, materialBrands, companyCertificates } = data
    let { buyerReq, buyerPOItems } = data

    if(!buyerReq){
        buyerReq = {
            buyerReqId: null,
            orderTypeId: null
        }
    }

    if(!buyerPOItems){
        buyerPOItems = []
    }
    let updatedRequiredApprovals = [] 

    let isUnitPriceApprovalReq = false
    let isSellerPOBrandCertificateApprovalNeeded = false

    let displayTitle = ""
    let updatedSellerPO = sellerPO

    if(!sellerPO.expenseCategoryId){
        isUnitPriceApprovalReq = sellerPOItems?.some(eachSellerPOItem => {
            const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === eachSellerPOItem?.buyerReqItemId && eachBuyerQuoteItem?.statusId === 1 && eachBuyerQuoteItem?.totReqQty > 0)
            let totalSellerQuotPrice = 0
            let validSellerQuoteCount = 0
            relatedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
                const relatedQuoteSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachBuyerQuoteItem.sellerReqItemId)
                const relatedSellerReq = sellerReqs?.find(eachSellerReq => eachSellerReq.sellerReqId === relatedQuoteSellerReqItem?.sellerReqId)
                if(![3625].includes(relatedSellerReq?.companyId)){
                    totalSellerQuotPrice += eachBuyerQuoteItem.bQuotSellerQty * parseFloat(eachBuyerQuoteItem.bQuotSellerPrice)
                    validSellerQuoteCount += eachBuyerQuoteItem.bQuotSellerQty
                }
            })

            const relatedSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === eachSellerPOItem.sellerReqItemId)
            
            let today = moment()
            const monthsSinceSellerRequestItemCreated = today.diff(relatedSellerReqItem.createdAt, 'months')

            let avgSellerQuotPrice = round(totalSellerQuotPrice / validSellerQuoteCount)
            const variationPercent = ((eachSellerPOItem.unitPrice - avgSellerQuotPrice) / avgSellerQuotPrice) * 100

            if (monthsSinceSellerRequestItemCreated > 6){
                displayTitle = `SELLER PO - AGED SELLER REQ ITEM APPROVAL`
            }

            return (variationPercent > 1 || monthsSinceSellerRequestItemCreated > 6) && sellerPO.companyId !== sellerPO.pmCompanyId
        })

        let isBrandCertificateMissing = false
        sellerPOItems.map(eachSellerPOItem => {
            const relatedMaterial = materialMasterData.find(eachMaterialDetail => eachMaterialDetail.materialId === eachSellerPOItem.materialId)
            const relatedMaterialBrand = materialBrands?.find(eachMaterialBrand => eachMaterialBrand.brandId === relatedMaterial.brandId)
            if (relatedMaterialBrand?.config?.certificateProofMandatory){
                const relatedCompanyBrandCertificate = companyCertificates.find(eachCompanyCertificate => eachCompanyCertificate.companyId === sellerPO.companyId && eachCompanyCertificate.entityId === relatedMaterialBrand.brandId && eachCompanyCertificate.statusId === 1 && moment(new Date()).format("YYYY-MM-DD") <= eachCompanyCertificate.expiryDate)
                if (!relatedCompanyBrandCertificate){
                    isBrandCertificateMissing = true
                }
            }
        })

        if ((!buyerReq.isRouted || sellerPO.companyId !== sellerPO.pmCompanyId) && isBrandCertificateMissing){
            isSellerPOBrandCertificateApprovalNeeded = true
        }
    }

    let presentCreditPeriod = companyCreditPeriods?.find(eachCompanyPeriod => eachCompanyPeriod?.creditPeriodId === sellerPO?.paymentTerms?.creditPeriodId)
    let previousCreditPeriod = companyCreditPeriods?.find(eachCompanyPeriod => eachCompanyPeriod?.creditPeriodId === sellerCompanyDetails?.paymentTerms?.creditPeriodId)
    
    let amountStr = ""
    let amount = 0
    if(!totalAmtFlag){
        amountStr = replaceStr(updatedSellerPO?.totalItemAmountWithTax, ",", "")
        amount = parseFloat(amountStr)
    } else {
        amount = updatedSellerPO?.totalItemAmountWithTax
    }
    
    POApprovals?.map(eachApproval => {
        if (sellerPIPunch?.length === 0 && updatedSellerPO.statusId === 3) {
            if (eachApproval?.approvalTypeId === 9){
                const {isSellerPOPaymentTermsChanged, negativePaymentTermsExist} = getSellerPOPaymentTermChangeStatus(sellerPO, sellerCompanyDetails.paymentTerms)
                let isApprovalApplicable = false
                let remarks = ""
                if(negativePaymentTermsExist){
                    isApprovalApplicable = true
                } else if(!buyerReq.isRouted && !isSellerPOPaymentTermsChanged && !sellerPO.expenseCategoryId) {
                    if(nonRoutedSellerPOsInfo && parseInt(nonRoutedSellerPOsInfo.sellerPOCount) >= 5 && parseInt(nonRoutedSellerPOsInfo.totalAmount) > 200000){
                        isApprovalApplicable = true
                        remarks = "Mandatory Periodic Payment Terms Approval "
                    }
                }
                if (isApprovalApplicable){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                        statusId: 12,
                        isRequired: true,
                        remarks: remarks
                    })
                }
                
                // if (eachApproval.approvalId === 21) { // APPROVAL_CHANGE find by typeId
                //     let isApprovalApplicable = false
                //     let remarks = ""
                //     if(negativePaymentTermsExist){
                //         isApprovalApplicable = true
                //     } else if(!buyerReq.isRouted && !isSellerPOPaymentTermsChanged && !sellerPO.expenseCategoryId) {
                //         if(nonRoutedSellerPOsInfo && parseInt(nonRoutedSellerPOsInfo.sellerPOCount) >= 5 && parseInt(nonRoutedSellerPOsInfo.totalAmount) > 200000){
                //             isApprovalApplicable = true
                //             remarks = "Mandatory Periodic Payment Terms Approval "
                //         }
                //     }
                //     if (isApprovalApplicable){
                //         updatedRequiredApprovals.push({
                //             approvalId: eachApproval.approvalId,
                //             approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                //             statusId: 12,
                //             isRequired: true,
                //             remarks: remarks
                //         })
                //     }
                // } 
                // else if (eachApproval.approvalId === 30){ // APPROVAL_CHANGE find by typeId
                //     if (presentCreditPeriod?.creditPeriodId < previousCreditPeriod?.creditPeriodId && presentCreditPeriod?.creditPeriod >= 7){
                //         updatedRequiredApprovals.push({
                //             approvalId: eachApproval?.approvalId,
                //             approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                //             statusId: 12,
                //             isRequired: true,
                //             remarks: ''
                //         })
                //     }
        
                // }else if (eachApproval.approvalId === 31){ // APPROVAL_CHANGE find by typeId
                //     if (presentCreditPeriod?.creditPeriodId < previousCreditPeriod?.creditPeriodId && presentCreditPeriod?.creditPeriod < 7){
                //         updatedRequiredApprovals.push({
                //             approvalId: eachApproval?.approvalId,
                //             approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                //             statusId: 12,
                //             isRequired: true,
                //             remarks: ''
                //         })
                //     }
                // }
            }else if (eachApproval?.approvalTypeId === 16){
                if (isUnitPriceApprovalReq){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        statusId: 12,
                        isRequired: true,
                        remarks: '',
                        displayTitle: displayTitle
                    })
                }
            }else if (eachApproval.approvalTypeId === 17) {  
                const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)
    
                // console.log('upperLimit, lowerLimit', upperLimit, lowerLimit)
    
                if (lowerLimit <= amount && amount < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: amount },
                        statusId: 12,
                        remarks: ''
                    })
                }
            }else if (eachApproval?.approvalTypeId === 20){
                const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)

                if (lowerLimit <= amount && amount < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        approvedMetrics: { amount: amount },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }else if (eachApproval.approvalTypeId === 21) {  
                const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)
    
                if (lowerLimit <= amount && amount < upperLimit) {
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval.approvalId,
                        approvedMetrics: { amount: amount },
                        statusId: 12,
                        remarks: ''
                    })
                }
            }
            else if (eachApproval.approvalTypeId === 31 && buyerReq.orderTypeId === 2) {
                let isCategoryApprovalRequired = false
                let totalCategoryAmount = 0
                const { category_ids, upperLimit, lowerLimit } = getApprovalParams(eachApproval)

                sellerPOItems.forEach(eachPOItem => {
                    const relatedMaterial = materialMasterData.find(eachMaterial => eachMaterial.materialId === eachPOItem.materialId)
                    if (relatedMaterial && category_ids.includes(relatedMaterial.categoryId)) {
                        isCategoryApprovalRequired = true
                        totalCategoryAmount += eachPOItem.itemAmountWithTax
                    }
                })

                if (isCategoryApprovalRequired) {
                    if (lowerLimit <= totalCategoryAmount && totalCategoryAmount < upperLimit) {
                        updatedRequiredApprovals.push({
                            approvalId: eachApproval.approvalId,
                            approvedMetrics: { amount: totalCategoryAmount },
                            statusId: 12,
                            isRequired: true,
                            remarks: ''
                        })
                    }
                }
            }
            else if (eachApproval.approvalTypeId === 32 && buyerReq.orderTypeId === 2) {
                let isBrandApprovalRequired = false
                let totalBrandAmount = 0
                const { brand_id, upperLimit, lowerLimit } = getApprovalParams(eachApproval)

                sellerPOItems.forEach(eachPOItem => {
                    const relatedMaterial = materialMasterData.find(eachMaterial => eachMaterial.materialId === eachPOItem.materialId)
                    if (relatedMaterial && relatedMaterial.brandId === brand_id) {
                            isBrandApprovalRequired = true
                            totalBrandAmount += eachPOItem.itemAmountWithTax
                    }
                })

                if (isBrandApprovalRequired) {
                    if (lowerLimit <= totalBrandAmount && totalBrandAmount < upperLimit) {
                        updatedRequiredApprovals.push({
                            approvalId: eachApproval.approvalId,
                            approvedMetrics: { amount: totalBrandAmount },
                            statusId: 12,
                            isRequired: true,
                            remarks: ''
                        })
                    }
                }
            }
            else if (eachApproval.approvalTypeId === 33 && buyerReq.orderTypeId === 2) { 
                let totalLoss = 0
                sellerPOItems.forEach(eachSellerPOItem => {
                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                    if(relatedBuyerPOItem){
                        const buyerAmountBeforeTax = parseFloat(relatedBuyerPOItem.bPOUnitPrice) * parseFloat(eachSellerPOItem.qty)
                        const buyerAmountAfterTax = round(buyerAmountBeforeTax + (parseFloat(relatedBuyerPOItem.bPOGSTRate) * buyerAmountBeforeTax * 0.01))

                        if(buyerAmountAfterTax < round(eachSellerPOItem.itemAmountWithTax)){
                            totalLoss += buyerAmountAfterTax - round(eachSellerPOItem.itemAmountWithTax)
                        }
                    }
                })
                totalLoss = round(totalLoss)
    
                if (totalLoss < 0) {
                    const {upperLimit, lowerLimit} = getApprovalParams(eachApproval)
                    
                    if (lowerLimit <= Math.abs(totalLoss) && Math.abs(totalLoss) < upperLimit) {
                        updatedRequiredApprovals.push({
                            approvalId: eachApproval.approvalId,
                            approvedMetrics: { amount: totalLoss },
                            statusId: 12,
                            isRequired: false,
                            remarks: ''
                        })
                    }
                }
            }else if (eachApproval.approvalTypeId === 34){
                if (presentCreditPeriod?.creditPeriodId < previousCreditPeriod?.creditPeriodId && presentCreditPeriod?.creditPeriod >= 7){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }else if (eachApproval.approvalTypeId === 35){
                if (presentCreditPeriod?.creditPeriodId < previousCreditPeriod?.creditPeriodId && presentCreditPeriod?.creditPeriod < 7){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        approvedMetrics: { paymentTerms: sellerPO.paymentTerms },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }else if (eachApproval.approvalTypeId === 37){
                const isMaterialMandatoryAvailable = sellerPOItems.find(eachSellerPOItem => {
                    const relatedMaterialMandatoryUseFromStock = materialMandatoryUseFromStock.find(eachMandatoryMaterial => eachMandatoryMaterial.materialId === eachSellerPOItem.materialId)
        
                    if(relatedMaterialMandatoryUseFromStock){
                        return true
                    }
        
                    return false
                })

                if (isMaterialMandatoryAvailable && buyerReq.orderTypeId !== 3){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        approvedMetrics: { amount: amount },
                        statusId: 12,
                        isRequired: true,
                        remarks: ''
                    })
                }
            }else if (eachApproval.approvalTypeId === 41){
                const {upperLimit, lowerLimit, category_ids, pmBranchIds} = getApprovalParams(eachApproval)

                if (buyerReq.orderTypeId === 2){
                    let isCategoryApprovalRequired = false
                    sellerPOItems.forEach(eachPOItem => {
                        const relatedMaterial = materialMasterData.find(eachMaterial => eachMaterial.materialId === eachPOItem.materialId)
                        if (relatedMaterial && category_ids.includes(relatedMaterial.categoryId)) {
                            isCategoryApprovalRequired = true
                        }
                    })
                    if (isCategoryApprovalRequired){
                        if (lowerLimit <= Math.abs(amount) && Math.abs(amount) < upperLimit) {
                            const requiredApprovalIds = updatedRequiredApprovals.map(eachRequiredApproval => eachRequiredApproval.approvalId)
                            const currentApprovalTypeRelatedApprovalIds = POApprovals.filter(eachQuoteApproval => eachQuoteApproval.approvalTypeId === eachApproval.approvalTypeId).map(eachQuoteApproval => eachQuoteApproval.approvalId)
                            if (pmBranchIds && pmBranchIds.length){
                                if (pmBranchIds.includes(updatedSellerPO.pmBranchId)){
                                    updatedRequiredApprovals = updatedRequiredApprovals.filter(eachRequiredApproval => {
                                        if (!currentApprovalTypeRelatedApprovalIds.includes(eachRequiredApproval.approvalId)){
                                            return eachRequiredApproval
                                        }
                                    })
                                    updatedRequiredApprovals.push({
                                        approvalId: eachApproval.approvalId,
                                        approvedMetrics: { amount: amount },
                                        statusId: 12,
                                        isRequired: false,
                                        remarks: ''
                                    })
                                }
                            }else {
                                const isCurrentApprovalTypeRelatedApprovalExists = currentApprovalTypeRelatedApprovalIds.some(eachApprovalId => requiredApprovalIds.includes(eachApprovalId))
            
                                if (!isCurrentApprovalTypeRelatedApprovalExists){
                                    updatedRequiredApprovals.push({
                                        approvalId: eachApproval.approvalId,
                                        approvedMetrics: { amount: amount },
                                        statusId: 12,
                                        isRequired: false,
                                        remarks: ''
                                    })
                                }
                            }
                        }
                    }
                }
            }else if (eachApproval.approvalTypeId === 42){
                if (buyerReq.orderTypeId === 2){
                    const {upperLimit, lowerLimit, category_ids, pmBranchIds} = getApprovalParams(eachApproval)

                    let totalLoss = 0
                    sellerPOItems.forEach(eachSellerPOItem => {
                        const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                        if(relatedBuyerPOItem){
                            const buyerAmountBeforeTax = parseFloat(relatedBuyerPOItem.bPOUnitPrice) * parseFloat(eachSellerPOItem.qty)
                            const buyerAmountAfterTax = round(buyerAmountBeforeTax + (parseFloat(relatedBuyerPOItem.bPOGSTRate) * buyerAmountBeforeTax * 0.01))

                            if(buyerAmountAfterTax < round(eachSellerPOItem.itemAmountWithTax)){
                                totalLoss += buyerAmountAfterTax - round(eachSellerPOItem.itemAmountWithTax)
                            }
                        }
                    })
                    totalLoss = round(totalLoss)

                    let isCategoryApprovalRequired = false
                    sellerPOItems.forEach(eachPOItem => {
                        const relatedMaterial = materialMasterData.find(eachMaterial => eachMaterial.materialId === eachPOItem.materialId)
                        if (relatedMaterial && category_ids.includes(relatedMaterial.categoryId)) {
                            isCategoryApprovalRequired = true
                        }
                    })

                    if (totalLoss < 0 && isCategoryApprovalRequired){
                        if (lowerLimit <= Math.abs(totalLoss) && Math.abs(totalLoss) < upperLimit) {
                            const requiredApprovalIds = updatedRequiredApprovals.map(eachRequiredApproval => eachRequiredApproval.approvalId)
                            const currentApprovalTypeRelatedApprovalIds = POApprovals.filter(eachQuoteApproval => eachQuoteApproval.approvalTypeId === eachApproval.approvalTypeId).map(eachQuoteApproval => eachQuoteApproval.approvalId)
            
                            if (pmBranchIds && pmBranchIds.length){
                                if (pmBranchIds.includes(updatedSellerPO.pmBranchId)){
                                    updatedRequiredApprovals = updatedRequiredApprovals.filter(eachRequiredApproval => {
                                        if (!currentApprovalTypeRelatedApprovalIds.includes(eachRequiredApproval.approvalId)){
                                            return eachRequiredApproval
                                        }
                                    })
                                    updatedRequiredApprovals.push({
                                        approvalId: eachApproval.approvalId,
                                        approvedMetrics: { amount: totalLoss },
                                        statusId: 12,
                                        isRequired: false,
                                        remarks: ''
                                    })
                                }
                            }else {
                                const isCurrentApprovalTypeRelatedApprovalExists = currentApprovalTypeRelatedApprovalIds.some(eachApprovalId => requiredApprovalIds.includes(eachApprovalId))
            
                                if (!isCurrentApprovalTypeRelatedApprovalExists){
                                    updatedRequiredApprovals.push({
                                        approvalId: eachApproval.approvalId,
                                        approvedMetrics: { amount: totalLoss },
                                        statusId: 12,
                                        isRequired: false,
                                        remarks: ''
                                    })
                                }
                            }
                        }
                    }
                }
            }else if (eachApproval.approvalTypeId === 44){
                if (isSellerPOBrandCertificateApprovalNeeded){
                    updatedRequiredApprovals.push({
                        approvalId: eachApproval?.approvalId,
                        statusId: 12,
                        isRequired: true,
                        remarks: '',
                        displayTitle: displayTitle
                    })
                }
            }
        }
    })
    return updatedRequiredApprovals
}

export const getApprovalRequestStatusDetails = (data) => {
    const { updatedRequiredApprovals, approvalInstances, approvals, pmBranchId, sellerPO, buyerPO } = data
    const approvalRequestStatusDetails = []
    const activeApprovalInstances = approvalInstances.filter(eachInstance => eachInstance.statusId !== 2)

    updatedRequiredApprovals.map(eachRequiredApproval => {
        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachRequiredApproval.approvalId)

        if (relatedApproval.approvalTypeId === 1) {  // >1Lac   
            let instanceObj = null

            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 2) { //loss 
            let instanceObj = null
            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 3) {  // brand 
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 4) {  // category 
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 5) {  // best seller comb
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId && eachRequiredApproval.materialId === eachApprovalInstance.materialId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 6) {  //Logistics GST
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount === eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount === eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount === eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 10) {  //Projects
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 28){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 

        else if (relatedApproval.approvalTypeId === 38){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 

        else if (relatedApproval.approvalTypeId === 39){
            let instanceObj = null

            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 

        else if (relatedApproval.approvalTypeId === 40) { 
            let instanceObj = null
            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }


        if (relatedApproval.approvalTypeId === 14) {
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 
        
        else if (relatedApproval.approvalTypeId === 22){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 

        else if (relatedApproval.approvalTypeId === 26){
            let instanceObj = null

            const relatedApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId && relatedApproval.companyId === buyerPO.companyId)
            const relatedApprovalIds = relatedApprovals.map(eachApproval => eachApproval.approvalId)
            let allApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedApprovalIds.includes(eachApprovalInstance.approvalId))

            let maxLevelId = _.maxBy(approvals, "levelId").levelId

            let currentApprovalLevelAt = 1
            allApprovalInstances.map(eachApprovalInstance => {
                if(eachApprovalInstance.statusId === 9){
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)
                    if(maxLevelId === relatedInstanceApproval.levelId){
                        currentApprovalLevelAt = relatedInstanceApproval.levelId
                    } 
                    else if(relatedInstanceApproval.levelId > currentApprovalLevelAt){
                        currentApprovalLevelAt = relatedInstanceApproval.levelId + 1
                    } 
                    else if(relatedInstanceApproval.levelId === currentApprovalLevelAt){
                        currentApprovalLevelAt = relatedInstanceApproval.levelId + 1
                    }
                }
            })

            if(currentApprovalLevelAt !== relatedApproval.levelId){
                return
            }

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }

            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 30) { // BUYER SIDE PO AMOUNT
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 32) {  
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 31) {  
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        else if (relatedApproval.approvalTypeId === 33) { 
            let instanceObj = null
            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        }

        if (relatedApproval.approvalTypeId === 9) {  // NEGATIVE PAYMENT TERMS
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    remarks: eachRequiredApproval.remarks,
                    prefillText: eachRequiredApproval.remarks,
                    requestStatus: "NOT REQUESTED"
                }
            }
            if(instanceObj){
                approvalRequestStatusDetails.push(instanceObj)
            }

        } else if (relatedApproval?.approvalTypeId === 16) { // NEGATIVE CREDIT PERIOD
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED",
                    displayTitle: eachRequiredApproval.displayTitle
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } else if (relatedApproval?.approvalTypeId === 17) { // PO AMOUNT
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } else if (relatedApproval?.approvalTypeId === 20) { // EXPENSE PO
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

             relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

           
            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } else if (relatedApproval?.approvalTypeId === 21) { // EXPENSE PO AMOUNT
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        } else if (relatedApproval.approvalTypeId === 34){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    remarks: eachRequiredApproval.remarks,
                    prefillText: eachRequiredApproval.remarks,
                    requestStatus: "NOT REQUESTED"
                }
            }
            if(instanceObj){
                approvalRequestStatusDetails.push(instanceObj)
            }
        } else if (relatedApproval.approvalTypeId === 35){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    remarks: eachRequiredApproval.remarks,
                    prefillText: eachRequiredApproval.remarks,
                    requestStatus: "NOT REQUESTED"
                }
            }
            if(instanceObj){
                approvalRequestStatusDetails.push(instanceObj)
            }
        } else if (relatedApproval.approvalTypeId === 37){
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED"
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED"
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED"
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    remarks: eachRequiredApproval.remarks,
                    prefillText: eachRequiredApproval.remarks,
                    requestStatus: "NOT REQUESTED"
                }
            }
            if(instanceObj){
                approvalRequestStatusDetails.push(instanceObj)
            }
        } else if (relatedApproval.approvalTypeId === 41){
            let instanceObj = null

            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount >= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } else if (relatedApproval.approvalTypeId === 42) { 
            let instanceObj = null
            const relatedTypeApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === relatedApproval.approvalTypeId)
            const relatedTypeApprovalIds = relatedTypeApprovals.map(eachApproval => eachApproval.approvalId)

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => relatedTypeApprovalIds.includes(eachApprovalInstance.approvalId))

            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8 && eachApprovalInstance.approvalId === eachApprovalInstance.approvalId)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "APPROVED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    const relatedInstanceApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)

                    if (Math.abs(eachRequiredApproval.approvedMetrics.amount) > relatedInstanceApproval.param1 && eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REQUESTED"
                        }
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    if (eachApprovalInstance.approvedMetrics.amount <= eachRequiredApproval.approvedMetrics.amount) {
                        instanceObj = {
                            ...eachApprovalInstance,
                            approvalTypeId: relatedApproval.approvalTypeId,
                            requestStatus: "REJECTED"
                        }
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED"
                }
            }
            approvalRequestStatusDetails.push(instanceObj)
        } else if (relatedApproval?.approvalTypeId === 44) { // SPOC
            let instanceObj = null

            const relatedApprovalInstances = activeApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === relatedApproval.approvalId)
            //console.log("relatedApprovalInstances", relatedApprovalInstances)
            const relatedApprovalInstanceWithRequestedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 12)
            const relatedApprovalInstanceWithApprovedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 9)
            const relatedApprovalInstanceWithRejectedStatus = relatedApprovalInstances.filter(eachApprovalInstance => eachApprovalInstance.statusId === 8)

            relatedApprovalInstanceWithApprovedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "APPROVED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            relatedApprovalInstanceWithRequestedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REQUESTED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            relatedApprovalInstanceWithRejectedStatus.map(eachApprovalInstance => {
                if (!instanceObj) {
                    instanceObj = {
                        ...eachApprovalInstance,
                        approvalTypeId: relatedApproval.approvalTypeId,
                        requestStatus: "REJECTED",
                        displayTitle: eachRequiredApproval.displayTitle
                    }
                }
            })

            if (!instanceObj) {
                instanceObj = {
                    ...eachRequiredApproval,
                    approvalTypeId: relatedApproval.approvalTypeId,
                    isNew: true,
                    requestStatus: "NOT REQUESTED",
                    displayTitle: eachRequiredApproval.displayTitle
                }
            }
            approvalRequestStatusDetails.push(instanceObj)

        } 
    })

    approvalRequestStatusDetails.map((eachRequest, index) => {
        eachRequest.srNo = index + 1
        eachRequest.requestedRemarks = eachRequest.remarks
        eachRequest.remarks = eachRequest.remarks || ""
        eachRequest.pmBranchId = pmBranchId
    })

    return approvalRequestStatusDetails
}

export const getPIVerificationStatusHTML = (sellerPIPunch) => {
    if(sellerPIPunch.verifiedBy){
        return <span className="text-teal-500">Verified</span>
    }
    else if(sellerPIPunch.skippedBy){
        return <span className="text-teal-500">Verification Skipped</span>
    }
    else{
        return <span className="text-red-600">Verification Pending</span>
    }
}

export const getMaterialMasterApproverTooltipHTML = (approvers, partialSpecsApprover, partialSpecsApprovalStatus) => {
    let partialSpecsApprovalText = ''
    if (partialSpecsApprover) {
        if (partialSpecsApprovalStatus === 12) {
            partialSpecsApprovalText = <span>RAISED to {partialSpecsApprover} for partial specs approval; </span>
        }
        else if (partialSpecsApprovalStatus === 8) {
            partialSpecsApprovalText = <span>REJECTED by {partialSpecsApprover} for partial specs approval; </span>
        }
    }

    return <>
        {<p className="m-0 p-0">{partialSpecsApprovalText}<span className="font-bold">Approver(s):</span> {approvers}</p>}
    </>
    // return <>
    //     {<p className="m-0"><span className="font-bold">Primary Approver:</span> {primaryApprover} | <span className="font-bold">Secondary Approver:</span> {secondaryApprover}</p>}
    // </>
}

export const getApprovalParams = (approvalsObj) => {

    let upperLimit = Infinity
    let lowerLimit = -Infinity

    let brand_id = null 
    let category_ids = []
    let pmBranchIds = []

    Object.keys(approvalsObj).map(eachKey => {
        // console.log("eachKey", eachKey)
        if(approvalsObj[eachKey] === 'UPPER_LIMIT'){
            upperLimit = approvalsObj[eachKey.split('_')[0]]
        }

        if(approvalsObj[eachKey] === 'LOWER_LIMIT'){
            lowerLimit = approvalsObj[eachKey.split('_')[0]]
        }

        if(approvalsObj[eachKey] === 'BRAND_ID'){
            brand_id = approvalsObj[eachKey.split('_')[0]]
        }

        if(approvalsObj[eachKey] === 'CATEGORY_ID'){
            category_ids = approvalsObj[eachKey.split('_')[0]]
        }

        if(approvalsObj[eachKey] === 'BRANCH_ID'){
            pmBranchIds = approvalsObj[eachKey.split('_')[0]]
        }
    })

    const range = {
        upperLimit: upperLimit,
        lowerLimit: lowerLimit,
        brand_id: brand_id,
        category_ids: category_ids,
        pmBranchIds: pmBranchIds
    }

    return range
}

export const getGeoPermissions = (data) => {
    const geoPermissions = {
        permGeo: data.permGeo
    }

    if(data.permGeo?.length){
        const clientBranchIds = []
        const procmartBranchIds = [] 
        data.permGeo.map(eachPermGeo => {
            if(eachPermGeo.permGeoLevel === "client-company-branch"){
                clientBranchIds.push(eachPermGeo.permGeoLevelId)
            }
            if(eachPermGeo.permGeoLevel === "PM-Branch"){
                procmartBranchIds.push(eachPermGeo.permGeoLevelId)
            }
        })
        geoPermissions.clientBranchIds = clientBranchIds
        geoPermissions.procmartBranchIds = procmartBranchIds
    }
    return geoPermissions
}

export const checkGeoPermissions = (data) => {
    const geoPermissions = {
        permGeo: data.permGeo
    }

    if(data.permGeo?.length){
        const clientBranchIds = []
        const procmartBranchIds = [] 
        data.permGeo.map(eachPermGeo => {
            if(eachPermGeo.permGeoLevel === "client-company-branch"){
                clientBranchIds.push(eachPermGeo.permGeoLevelId)
            }
            if(eachPermGeo.permGeoLevel === "PM-Branch"){
                procmartBranchIds.push(eachPermGeo.permGeoLevelId)
            }
        })
        geoPermissions.clientBranchIds = clientBranchIds
        geoPermissions.procmartBranchIds = procmartBranchIds
    }
    return geoPermissions
}

export const getCurrentFinancialYear = () => {
    var year = "";
    var today = new Date();
    if ((today.getMonth() + 1) <= 3) {
        year = (today.getFullYear() - 1)
    } else {
        year = today.getFullYear()
    }
    return {
        year: year,
        start_date: moment(`${year}-04-01`, 'YYYY-MM-DD').toDate()
    }
}

export const gstCalculation = (item) => {
    let { IGST, unitPrice, quantity ,CGST, SGST} = item
    if (unitPrice && quantity){
        const taxBeforePrice = unitPrice * quantity
        const igstValue = taxBeforePrice * IGST * 0.01
        const cgstValue = taxBeforePrice * CGST * 0.01
        const sgstValue = taxBeforePrice * SGST * 0.01
        const totalPrice = parseFloat(taxBeforePrice + igstValue + cgstValue + sgstValue )
        return { totalPrice, taxBeforePrice, igstValue, cgstValue, sgstValue}
    }
    return {}
}

export const totalPriceCalculation = (data) => {
    let totalPrice = 0
    
    data?.map((eachItem) => {
        if (eachItem.unitPrice && eachItem.quantity){
            const cost = parseFloat(eachItem.unitPrice) * parseFloat(eachItem.quantity)
            const tax = ( cost * parseFloat(eachItem.IGST) * 0.01 ) + ( cost * parseFloat(eachItem.CGST) * 0.01 ) + ( cost * parseFloat(eachItem.SGST) * 0.01 )
            totalPrice += cost + tax
            
        }
        return 0
    })
    return totalPrice
}

export const totalQuotationAmountCalculation = (data) => {
    let quotLogisticsWithTax = 0
    if (data?.quotLogisticsBeforeTax){
        quotLogisticsWithTax = round(parseInt(data.quotLogisticsBeforeTax) + (data.quotLogisticsBeforeTax * data.quotLogisticsGSTRate * 0.01), 4)
    }
    if (data.quotUnitPrice && data.quotQty){
        let totalAmountBeforeTax = round(data.quotUnitPrice * data.quotQty, 4)
        let gstTax = round(totalAmountBeforeTax * data.quotGSTRate * 0.01, 4)
        let totalAmountWithTax = round(totalAmountBeforeTax + gstTax, 4)
        if (data?.quotLogisticsBeforeTax){
            totalAmountBeforeTax += parseFloat(data?.quotLogisticsBeforeTax)
        }
        totalAmountWithTax += parseFloat(quotLogisticsWithTax)

        return { totalAmountBeforeTax, gstTax, quotLogisticsWithTax, totalAmountWithTax }
    }
    return { quotLogisticsWithTax }
}

export const validateInputs = async (schema, form_values, pmCompanyConfig) => {
    try {
        let result = await schema.validate(form_values, { abortEarly: false, context: pmCompanyConfig })
        return {result}
    } catch (error) {
        const updatedFormErrors = {}

        if(error.inner){
            error?.inner?.forEach((validationError) => {
                updatedFormErrors[validationError.path] = validationError.message
            })
            return {error:updatedFormErrors}
        }
    }
}

export const sortArrayOfObjectsInAlphabeticalOrder = (arr, fieldName) => {
    let sortedArr = arr.slice().sort((a, b) => {
        const fieldNameA = a[fieldName]?.toLowerCase();
        const fieldNameB = b[fieldName]?.toLowerCase();
        if (fieldNameA < fieldNameB){
            return -1
        }
        if (fieldNameA > fieldNameB) {
            return 1
        }
        return 0
    })
    return sortedArr
}

export const sortArrayOfObjectsInAscendingDateOrder = (arr, fieldName, order) => {
    let sortedArr = arr.slice().sort((a, b) => {
        const fieldNameA = a[fieldName]
        const fieldNameB = b[fieldName]
        if (Date.parse(fieldNameA) < Date.parse(fieldNameB)){
            return order && order === "DESC" ? 1 : -1
        }
        if (Date.parse(fieldNameA) > Date.parse(fieldNameB)) {
            // return 1
            return order && order === "DESC" ? -1 : 1
        }
        return 0
    })
    return sortedArr
}


export const getPercentile = (numbers, inputNumber) => {
    const sortedNumbers = _.sortBy(numbers)
    const numsLessThanInput = sortedNumbers.filter(eachNum => eachNum < inputNumber)
    const numsBrforeInputNum = numsLessThanInput.length

    const percentile = round(((numsBrforeInputNum + 0.5) / sortedNumbers.length) * 100, 0)

    return percentile
}

export const getReversePercentile = (numbers, inputNumber) => {
    const sortedNumbers = _.sortBy(numbers)
    const numsGreaterOrEqual = sortedNumbers.filter(eachNum => eachNum >= inputNumber)
    const numsAfterInputNum = numsGreaterOrEqual.length

    const percentile = round(((numsAfterInputNum - 0.5) / sortedNumbers.length) * 100, 0)

    return percentile
}

export const trimmedInputValues = (value) => value ? value.trim() : value

export const capitalizeWordsInValue = (value) => {
    let words = []
    if(value){
        words = value?.split(' ')
    }

    let capitalizedWords = []
    words?.forEach(word => {
        if (word) {
            capitalizedWords.push(word[0].toUpperCase() + word.slice(1, word.length).toLowerCase())
        }
    })

    return capitalizedWords.join(' ')
}


export const getMostRepeatedOneInArray = (arr, fieldName) => {
    const frequencyMap = {};
  
    // Populate the frequency map
    for (const obj of arr) {
        const id = obj[fieldName];
        if (frequencyMap[id]) {
        frequencyMap[id]++;
        } else {
        frequencyMap[id] = 1;
        }
    }
    
    let maxCount = 0;
    let mostFrequentId;
    for (const id in frequencyMap) {
        if (frequencyMap[id] > maxCount) {
        maxCount = frequencyMap[id];
        mostFrequentId = id;
        }
    }

    return mostFrequentId
}

export const panAndGstinMatchValidation = (context, gstin) => {
    if(context.parent.panCode && gstin){
        if(gstin.slice(2,12) !== context.parent.panCode){
            return context.createError({ path: context.path, message: "GSTIN and PAN entered are not for the same entity" });
        }
        return true
    }
}

export const calculateStockGSTAndPrice = (qty, smartStockMoves) => {

    if (!smartStockMoves?.length) {
        return 0
    }

    let numerator = 0
    let denominator = 0
    let gstRates = []
    let consumableSmartStockMoves = []

    smartStockMoves.forEach(eachSmartStockMove => {
        if (qty > 0) {
            if ((qty - parseFloat(eachSmartStockMove.moveQty)) >= 0) {
                numerator += parseFloat(eachSmartStockMove.moveQty) * parseFloat(eachSmartStockMove.price)
                denominator += parseFloat(eachSmartStockMove.moveQty)
            }
            if ((qty - parseFloat(eachSmartStockMove.moveQty)) < 0) {
                numerator += parseFloat(qty) * parseFloat(eachSmartStockMove.price)
                denominator += parseFloat(qty)
            }
            gstRates.push(eachSmartStockMove.GSTRate)
            consumableSmartStockMoves.push(eachSmartStockMove)
        }
        qty = qty - parseFloat(eachSmartStockMove.moveQty)
    })

    const newUnitPrice = round(numerator / denominator)

    let GSTRate = _.max(gstRates)
    if (!GSTRate && GSTRate !== 0) {
        GSTRate = null
    }

    return { unitPrice: newUnitPrice, GSTRate, consumableSmartStockMoves }
}

export const calculateAddExpense = (sellerPO, sellerPOItems) => {

    let totalAmountBeforeTax = 0
    let totalPOTax = 0 
    let totalAmountWithTax = 0

    let logisticsBeforeTax = 0
    let logisticsTax = 0
    let logisticsWithTax = 0

    let updatedSellerPOItems = sellerPOItems?.map(eachSellerPOItem => {
        let priceBeforeTax = 0
        let priceAfterTax = 0
        let totalTax = 0

        if (eachSellerPOItem?.qty && eachSellerPOItem?.unitPrice){
            priceBeforeTax = round(parseFloat(eachSellerPOItem.unitPrice) * parseFloat(eachSellerPOItem?.qty), 2)
            totalTax = round(priceBeforeTax * parseFloat(eachSellerPOItem.GSTRate) * 0.01)
            priceAfterTax = round(priceBeforeTax + totalTax, 2)
        }
        if(priceBeforeTax){
            totalAmountBeforeTax = totalAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            totalPOTax = totalPOTax + totalTax
        }

        let tdsAmount = 0
        if(eachSellerPOItem.tdsValue){
            tdsAmount = round(eachSellerPOItem.itemAmountBeforeTax * parseFloat(eachSellerPOItem.tdsValue) * 0.01)
        }

        const updatedSellerPOItem = { ...eachSellerPOItem, tdsAmount: tdsAmount, itemAmountBeforeTax : priceBeforeTax, itemAmountWithTax : priceAfterTax, itemTotalTax : totalTax }
        return updatedSellerPOItem
    })

    if(sellerPO?.logisticsBeforeTax){
        logisticsBeforeTax = parseFloat(sellerPO.logisticsBeforeTax)
        logisticsTax = logisticsBeforeTax * sellerPO.logisticsGSTRate * 0.01
        totalPOTax += logisticsTax
        logisticsWithTax = parseFloat(logisticsBeforeTax + logisticsTax)
    }

    totalAmountWithTax = totalAmountBeforeTax + totalPOTax

    sellerPO.totalItemAmountBeforeTax = totalAmountBeforeTax + logisticsBeforeTax
    sellerPO.totalPOTax = totalPOTax 
    // sellerPO.totalPOTax = totalPOTax
    sellerPO.totalItemAmountWithTax = sellerPO.totalItemAmountBeforeTax + totalPOTax
    sellerPO.totalPOAmount = parseInt(sellerPO.totalItemAmountWithTax)

    sellerPO.logisticsBeforeTax = logisticsBeforeTax
    sellerPO.logisticsWithTax = logisticsWithTax

    return {
        sellerPO: {...sellerPO},
        sellerPOItems: updatedSellerPOItems
    }

}

export const calculateBuyerQuotation = (buyerQuote, buyerQuoteItems) => {
    let bQuotTotalItemAmountBeforeTax = 0
    let bQuotTotalPOTax = 0
    let bQuotTotalItemAmountWithTax = 0

    let bQuotLogisticsBeforeTax = 0
    let bQuotLogisticsGSTRate = buyerQuote.bQuotLogisticsGSTRate
    let bQuotLogisticsWithTax = 0
    
    let updatedBuyerQuoteItems = buyerQuoteItems.map((eachBuyerQuoteItem) => {
        let sellerPriceBeforeTax = null
        let sellerTotalTax = null
        let sellerPriceAfterTax = null

        if (eachBuyerQuoteItem.bQuotSellerPrice && eachBuyerQuoteItem.bQuotSellerQty){
            sellerPriceBeforeTax = round(parseFloat(eachBuyerQuoteItem.bQuotSellerPrice) * parseFloat(eachBuyerQuoteItem.bQuotSellerQty))
            sellerTotalTax = round(sellerPriceBeforeTax * parseFloat(eachBuyerQuoteItem.bQuotSellerGSTRate) * 0.01)
            sellerPriceAfterTax = sellerPriceBeforeTax + sellerTotalTax
        }
        eachBuyerQuoteItem.sellerPriceBeforeTax = sellerPriceBeforeTax
        eachBuyerQuoteItem.sellerTotalTax = sellerTotalTax
        eachBuyerQuoteItem.sellerPriceAfterTax = sellerPriceAfterTax

        return eachBuyerQuoteItem
    })

    const buyerReqItemIds = _.uniqBy(updatedBuyerQuoteItems, 'buyerReqItemId').map(obj => obj.buyerReqItemId)

    let totalSellerLogistics = 0

    buyerReqItemIds.map(eachBuyerReqItemId => {
        const relatedBuyerQuoteItems = updatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItemId)
        const firstBuyerQuoteItem = relatedBuyerQuoteItems[0]

        const selectedBuyerQuoteItems = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bQuotSellerQty)

        const weightedSum = _.sumBy(selectedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bQuotSellerQty))
        const totalQuantity = _.sumBy(selectedBuyerQuoteItems, obj => parseFloat(obj.bQuotSellerQty))
        const weightedAverageSellerPrice = round(weightedSum / totalQuantity, 2)

        let priceBeforeTax = null
        let totalTax = 0
        let priceAfterTax = null

        if (firstBuyerQuoteItem.bQuotUnitPrice && firstBuyerQuoteItem.totReqQty){
            priceBeforeTax = parseFloat(firstBuyerQuoteItem.bQuotUnitPrice) * parseFloat(firstBuyerQuoteItem.totReqQty)
            totalTax = priceBeforeTax * parseFloat(firstBuyerQuoteItem.bQuoteGSTRate) * 0.01
            priceAfterTax = priceBeforeTax + totalTax
        }

        if(priceBeforeTax){
            bQuotTotalItemAmountBeforeTax = bQuotTotalItemAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            bQuotTotalPOTax = bQuotTotalPOTax + totalTax
        }

        relatedBuyerQuoteItems.map(eachRelatedBuyerQuoteItem => {
            eachRelatedBuyerQuoteItem.bQuoteItemAmountBeforeTax = round(priceBeforeTax)
            eachRelatedBuyerQuoteItem.bQuoteItemTaxAmount = round(totalTax)
            eachRelatedBuyerQuoteItem.bQuoteItemAmountWithTax = round(priceAfterTax)
            eachRelatedBuyerQuoteItem.avgSellerPrice = weightedAverageSellerPrice
            eachRelatedBuyerQuoteItem.bQuotUnitPrice = firstBuyerQuoteItem.bQuotUnitPrice
            eachRelatedBuyerQuoteItem.bQuotDiscountRate = firstBuyerQuoteItem.bQuotDiscountRate
            eachRelatedBuyerQuoteItem.bQuotMarginRate = firstBuyerQuoteItem.bQuotMarginRate

            if(eachRelatedBuyerQuoteItem.bQuotSellerQty > 0){
                let sellerUnitLogistics = eachRelatedBuyerQuoteItem.sellerUnitLogistics
                if(sellerUnitLogistics){
                    totalSellerLogistics += round(sellerUnitLogistics * eachRelatedBuyerQuoteItem.bQuotSellerQty)
                }
            }
        })
    })
    
    buyerQuote.totalSellerLogistics = round(totalSellerLogistics)

    if(buyerQuote.bQuoteLogisticsOption === "Delivery Charges Extra"){
        bQuotLogisticsBeforeTax = round(buyerQuote.bQuotLogisticsBeforeTax, 2)
        const logisticsTaxAmount = round(bQuotLogisticsBeforeTax * parseFloat(bQuotLogisticsGSTRate) * 0.01, 2)
        bQuotTotalPOTax += logisticsTaxAmount
        buyerQuote.logisticsTaxAmount = logisticsTaxAmount
        bQuotLogisticsWithTax = bQuotLogisticsBeforeTax + logisticsTaxAmount
    }
    buyerQuote.bQuotLogisticsBeforeTax = bQuotLogisticsBeforeTax
    buyerQuote.bQuotLogisticsGSTRate = bQuotLogisticsGSTRate
    buyerQuote.bQuotLogisticsWithTax = bQuotLogisticsWithTax

    bQuotTotalItemAmountBeforeTax = bQuotTotalItemAmountBeforeTax + bQuotLogisticsBeforeTax
    bQuotTotalItemAmountWithTax = bQuotTotalItemAmountBeforeTax + bQuotTotalPOTax

    buyerQuote.bQuotTotalItemAmountBeforeTax = round(bQuotTotalItemAmountBeforeTax)  //change here!
    buyerQuote.bQuotTotalPOTax = round(bQuotTotalPOTax, 2)
    buyerQuote.bQuotTotalItemAmountWithTax = round(bQuotTotalItemAmountWithTax, 2)
    buyerQuote.totalPOAmount = round(Math.round(bQuotTotalItemAmountWithTax), 2)

    return {
        buyerQuote: {...buyerQuote},
        buyerQuoteItems: updatedBuyerQuoteItems
    }
}

export const calculateBuyerPO = (buyerPO, buyerPOItems) => {
    let bPOTotalAmountBeforeTax = 0
    let bPOTotalTax = 0
    let bPOTotalAmountWithTax = 0

    let bPOLogisticsBeforeTax = 0
    let bPOLogisticsGSTRate = 0
    let bPOLogisticsWithTax = 0

    let gstRateArr = []

    let updatedBuyerPOItems = buyerPOItems.map((eachbuyerPOItem) => {
        let priceBeforeTax = 0
        let totalTax = 0
        let priceAfterTax = 0

        if (eachbuyerPOItem.bPOUnitPrice && eachbuyerPOItem.bPOQty){
            priceBeforeTax = parseFloat(eachbuyerPOItem.bPOUnitPrice) * parseFloat(eachbuyerPOItem.bPOQty)
            totalTax = priceBeforeTax * parseFloat(eachbuyerPOItem.bPOGSTRate) * 0.01
            priceAfterTax = priceBeforeTax + totalTax
        }

        if(priceBeforeTax){
            bPOTotalAmountBeforeTax = bPOTotalAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            bPOTotalTax = bPOTotalTax + totalTax
        }

        gstRateArr.push(eachbuyerPOItem.bPOGSTRate)

        return {...eachbuyerPOItem, bPOItemAmountBeforeTax: priceBeforeTax, bPOItemAmountWithTax : priceAfterTax}
    })

    gstRateArr = _.uniqBy(gstRateArr)

    const maxGstRate = _.max(gstRateArr)

    if(buyerPO.bPOlogisticsOption === "Delivery Charges Extra"){
        bPOLogisticsBeforeTax = buyerPO.bPOLogisticsBeforeTax
        bPOLogisticsGSTRate = maxGstRate
        const logisticsTaxAmount = bPOLogisticsBeforeTax * parseInt(maxGstRate) * 0.01
        bPOTotalTax += logisticsTaxAmount
        bPOLogisticsWithTax = bPOLogisticsBeforeTax + logisticsTaxAmount
    }
    buyerPO.bPOLogisticsBeforeTax = bPOLogisticsBeforeTax
    buyerPO.bPOLogisticsGSTRate = bPOLogisticsGSTRate
    buyerPO.bPOLogisticsWithTax = bPOLogisticsWithTax

    // bPOTotalAmountWithTax = bPOTotalAmountBeforeTax + bPOTotalTax

    buyerPO.bPOTotalAmountBeforeTax = bPOTotalAmountBeforeTax + bPOLogisticsBeforeTax
    buyerPO.bPOTotalTax = bPOTotalTax
    buyerPO.bPOTotalAmountWithTax = buyerPO.bPOTotalAmountBeforeTax + bPOTotalTax
    buyerPO.totalPOAmount = round(Math.round(buyerPO.bPOTotalAmountWithTax), 2)

    return {
        buyerPO: {...buyerPO},
        buyerPOItems: updatedBuyerPOItems
    }
}

export const calculateSellerPO = (sellerPO, sellerPOItems) => {

    let totalAmountBeforeTax = 0
    let totalPOTax = 0 
    let totalAmountWithTax = 0

    let logisticsBeforeTax = 0
    let logisticsTax = 0
    let logisticsWithTax = 0

    let updatedSellerPOItems = sellerPOItems?.map(eachSellerPOItem => {
        let priceBeforeTax = 0
        let priceAfterTax = 0
        let totalTax = 0

        if (eachSellerPOItem?.qty && eachSellerPOItem?.unitPrice){
            priceBeforeTax = round(parseFloat(eachSellerPOItem.unitPrice) * parseFloat(eachSellerPOItem?.qty), 2)
            totalTax = round(priceBeforeTax * parseFloat(eachSellerPOItem.GSTRate) * 0.01)
            priceAfterTax = round(priceBeforeTax + totalTax, 2)
        }

        if(priceBeforeTax){
            totalAmountBeforeTax = totalAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            totalPOTax = totalPOTax + totalTax
        }

        let tdsAmount = 0
        if(eachSellerPOItem.tdsValue){
            tdsAmount = round(eachSellerPOItem.itemAmountBeforeTax * parseFloat(eachSellerPOItem.tdsValue) * 0.01)
        }

        const updatedSellerPOItem = { ...eachSellerPOItem, tdsAmount: tdsAmount, itemAmountBeforeTax : priceBeforeTax, itemAmountWithTax : priceAfterTax, itemTotalTax : totalTax }
        return updatedSellerPOItem
    })

    if(sellerPO.logisticsBeforeTax){
        logisticsBeforeTax = parseFloat(sellerPO.logisticsBeforeTax)
        logisticsTax = logisticsBeforeTax * sellerPO.logisticsGSTRate * 0.01
        // totalPOTax += logisticsTax
        logisticsWithTax = parseFloat(logisticsBeforeTax + logisticsTax)
    }

    totalAmountWithTax = totalAmountBeforeTax + totalPOTax

    sellerPO.totalItemAmountBeforeTax = totalAmountBeforeTax + logisticsBeforeTax
    sellerPO.totalPOTax = totalPOTax + logisticsTax
    // sellerPO.totalPOTax = totalPOTax
    sellerPO.totalItemAmountWithTax = totalAmountWithTax + logisticsWithTax
    sellerPO.totalPOAmount = round(Math.round(sellerPO.totalItemAmountWithTax), 2)

    sellerPO.logisticsBeforeTax = logisticsBeforeTax
    sellerPO.logisticsWithTax = logisticsWithTax

    return {
        sellerPO: {...sellerPO},
        sellerPOItems: updatedSellerPOItems
    }

}

export const calculateSellerPI = (sellerPIPunch, sellerPIPunchItems) => {
    let sellerPILogisticsWithTax = 0
    let sellerPICalculatedTotalAmount = 0

    let totalAmountBeforeTax = 0
    let totalPOTax = 0 
    let totalAmountWithTax = 0

    let logisticsBeforeTax = 0
    let logisticsTax = 0
    let logisticsWithTax = 0

    let updatedSellerPIPunchItems = sellerPIPunchItems?.map(eachSellerPIPunchItem => {
        let priceBeforeTax = 0
        let priceAfterTax = 0
        let totalTax = 0

        let tdsAmount = 0
        if(eachSellerPIPunchItem.tdsValue){
            tdsAmount = round(eachSellerPIPunchItem.itemAmountBeforeTax * parseFloat(eachSellerPIPunchItem.tdsValue) * 0.01, 2)
        }

        if (eachSellerPIPunchItem?.inputQty && eachSellerPIPunchItem?.unitPrice){
            priceBeforeTax = parseFloat(eachSellerPIPunchItem.unitPrice) * parseFloat(eachSellerPIPunchItem?.inputQty)
            totalTax = priceBeforeTax * parseFloat(eachSellerPIPunchItem.GSTRate) * 0.01
            priceAfterTax = priceBeforeTax + totalTax
        }

        if(priceBeforeTax){
            totalAmountBeforeTax = totalAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            totalPOTax = totalPOTax + totalTax
        }

        // if (sellerPO?.logisticsBeforeTax){
        //     let logisticsWithTax = sellerPO?.logisticsBeforeTax + sellerPO?.logisticsBeforeTax * parseFloat(eachSellerPOItem?.GSTRate) * 0.01
        //     sellerPILogisticsWithTax += logisticsWithTax
        // }
       
        sellerPICalculatedTotalAmount = sellerPICalculatedTotalAmount + priceAfterTax

        const updatedSellerPIPunchItem = { ...eachSellerPIPunchItem, tdsAmount: tdsAmount, itemAmountBeforeTax: priceBeforeTax, itemAmountWithTax: priceAfterTax, itemTotalTax: totalTax }
        return updatedSellerPIPunchItem

    })

    if(sellerPIPunch?.logisticsBeforeTax){
        logisticsBeforeTax = parseFloat(sellerPIPunch?.logisticsBeforeTax)
        logisticsTax = parseFloat(logisticsBeforeTax * sellerPIPunch?.logisticsGSTRate * 0.01)
        logisticsWithTax = parseFloat(logisticsBeforeTax) + parseFloat(logisticsTax)
    }
    

    totalAmountWithTax = totalAmountBeforeTax + totalPOTax
    sellerPIPunch.totalItemAmountBeforeTax = totalAmountBeforeTax
    sellerPIPunch.totalPOTax = totalPOTax
    sellerPIPunch.totalItemAmountWithTax = totalAmountWithTax + parseFloat(sellerPIPunch?.sellerPILogisticsWithTax)
    sellerPIPunch.totalPOAmount = parseInt(totalAmountWithTax)

    sellerPIPunch.logisticsBeforeTax = logisticsBeforeTax
    sellerPIPunch.logisticsWithTax = logisticsWithTax

    sellerPIPunch.sellerPIAmountBeforeTax = logisticsBeforeTax + totalAmountBeforeTax

    sellerPIPunch.sellerPICalculatedTotalAmount = round(sellerPICalculatedTotalAmount + parseFloat(sellerPIPunch?.sellerPILogisticsWithTax), 2)
    // sellerPO.sellerPILogisticsWithTax = logisticsWithTax

    return {
        sellerPIPunch: {...sellerPIPunch},
        sellerPIPunchItems: updatedSellerPIPunchItems
    }
}

export const constructVPWiseSellerPOPaymentDetails = (sellerPODetails, vendorPayments) => {
    const activeVendorPayments = vendorPayments.filter(eachVendorPayment => ![2, 6, 8, 11].includes(eachVendorPayment.statusId))

    let sellerPOAdvancePOPaymentRequestedAmount = 0
    let sellerPOAdvancePaymentRequestedAmount = 0
    let sellerPOPDCOnDeliveryPaymentRequestedAmount = 0

    let payAdvPORequestedAmount = 0
    let payAdvDeliveryRequestedAmount = 0
    let payPDCDeliveryRequestedAmount = 0
    let payOnDeliveryRequestedAmount = 0
    let payCreditRequestedAmount = 0

    activeVendorPayments.map(vp => {
        if(vp.paymentTerm === 'payAdvPO'){
            payAdvPORequestedAmount += vp.amount
            if(vp.tdsAmount){
                payAdvPORequestedAmount += vp.tdsAmount
            }
        }
        if(vp.paymentTerm === 'payAdvDelivery'){
            payAdvDeliveryRequestedAmount += vp.amount
            if(vp.tdsAmount){
                payAdvDeliveryRequestedAmount += vp.tdsAmount
            }
        }
        if(vp.paymentTerm === 'payPDCDelivery'){
            payPDCDeliveryRequestedAmount += vp.amount
            if(vp.tdsAmount){
                payPDCDeliveryRequestedAmount += vp.tdsAmount
            }
        }
        if(vp.paymentTerm === 'payOnDelivery'){
            payOnDeliveryRequestedAmount += vp.amount
            if(vp.tdsAmount){
                payOnDeliveryRequestedAmount += vp.tdsAmount
            }
        }
        if(vp.paymentTerm === 'payCredit'){
            payCreditRequestedAmount += vp.amount
            if(vp.tdsAmount){
                payCreditRequestedAmount += vp.tdsAmount
            }
        }
    })

    const advanceTDSVendorPayment = activeVendorPayments.find(eachVendorPayment => [12, 10, 9].includes(eachVendorPayment.statusId) && ["payAdvPO", "payAdvDelivery", "payPDCDelivery"].includes(eachVendorPayment.paymentTerm) && eachVendorPayment.tdsAmount > 0)

    let sellerPOTotalPriceBeforeTax = 0
    let sellerPOTotalPrice = 0
    let sellerPOTotalTax = 0
    let totalTDSAmount = 0
    let materialsTotalTDSAmount = 0
    let sellerPOTotalItemAmountBeforeTax = 0

    let servicesTDSAmount = 0
    let goodsTDSAmount = 0

    let TDSAmountIfServicesWerePunchedSeperately = 0
    let TDSAmountIfServicesWerePunchedTogeather = 0

    let goodsTotalPriceBeforeTax = 0
    let servicesTotalPriceBeforeTax = 0

    let sellerPOMaterialsTotalPriceBeforeTax = 0

    let gstRateArr = []
    let gstValueArr = []

    let totalItemTDSAmount = 0
    let logisticsTDSAmount = 0

    let services = []
    let goods = []

    let isAllItemsAreServices = false
    let isAllItemsAreGoods = false

    sellerPODetails.sellerPOItems.map(eachSellerPOItem => {
        if(![2, 6].includes(eachSellerPOItem.statusId)){
            let rejectedQuantity = 0
            let shortQuantity = 0

            let relatedSellerGRNQCPunches = sellerPODetails.sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.buyerReqItemId === eachSellerPOItem.buyerReqItemId && eachSellerGRNQCPunch.statusId === 1)
            relatedSellerGRNQCPunches.sort((a, b) => b.createdAt - a.createdAt)

            if(relatedSellerGRNQCPunches.length > 0){
                const GRNQCPunch = relatedSellerGRNQCPunches[0]

                rejectedQuantity = GRNQCPunch.rejectedQuantity
                shortQuantity = GRNQCPunch.shortQuantity
            }

            const relatedSellerPIPunchItems = sellerPODetails.sellerPIPunchItems.filter(eachPIPunchItem => eachPIPunchItem.sellerPOItemId === eachSellerPOItem.sellerPOItemId && eachPIPunchItem.statusId === 1)

            const relatedSellerPIPunchItemIds = relatedSellerPIPunchItems.map(eachPIPunchItem => eachPIPunchItem.sellerPIPunchItemId)

            const relatedSellerDebitNoteItems = sellerPODetails.sellerDebitNoteItems?.filter(eachDebitNoteItem => relatedSellerPIPunchItemIds.includes(eachDebitNoteItem.sellerPIPunchItemId)) || []
            let debitNoteQuantity = 0
            relatedSellerDebitNoteItems.map(eachDebitNoteItem => {
                debitNoteQuantity += eachDebitNoteItem.adjustedQty
            })

            let quantity = round(eachSellerPOItem.qty - debitNoteQuantity, 3) //round(eachSellerPOItem.qty - rejectedQuantity - shortQuantity, 3)
            let priceBeforeTax = parseFloat(quantity) * parseFloat(eachSellerPOItem.unitPrice)
            let taxAmount = 0

            if(eachSellerPOItem.GSTRate){
                gstRateArr.push(eachSellerPOItem.GSTRate)
                taxAmount = priceBeforeTax * eachSellerPOItem.GSTRate / 100
                gstValueArr.push(taxAmount)
            }
            let totalPrice = priceBeforeTax + taxAmount

            sellerPOTotalPriceBeforeTax += priceBeforeTax
            sellerPOTotalItemAmountBeforeTax += priceBeforeTax
            sellerPOTotalTax += taxAmount
            sellerPOTotalPrice += totalPrice

            if(eachSellerPOItem.HSNCode.toString().slice(0,2) === "99" && eachSellerPOItem.HSNCode.toString().length === 6){
                sellerPOMaterialsTotalPriceBeforeTax += priceBeforeTax
                servicesTotalPriceBeforeTax += priceBeforeTax
                services.push(eachSellerPOItem)
            } else {
                goods.push(eachSellerPOItem)
                goodsTotalPriceBeforeTax += priceBeforeTax
            }

            if (eachSellerPOItem.tdsSection) {
                let tdsAmount = parseFloat(priceBeforeTax) * parseFloat(parseFloat(eachSellerPOItem.tdsValue) / 100)
                totalItemTDSAmount = totalItemTDSAmount + tdsAmount
            }
        }
    })

    let isPIWithBothServiceAndGoodsExists = false
    let isPIWithOnlyServicesOrOnlyGoodsExists = false

    if(sellerPODetails.sellerPIPunch){
        sellerPODetails.sellerPIPunch.map(eachSellerPIPunch => {
            if(eachSellerPIPunch.statusId === 1){
                const relatedSellerPIPunchItems = sellerPODetails.sellerPIPunchItems.filter(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPIPunchId === eachSellerPIPunch.sellerPIPunchId)

                let serviceExists = false
                let goodsExists = false
                relatedSellerPIPunchItems.map(eachPIPunchItem => {
                    const relatedSellerPOItem = sellerPODetails.sellerPOItems.find(eachPOItem => eachPOItem.sellerPOItemId === eachPIPunchItem.sellerPOItemId)
                    if(relatedSellerPOItem.HSNCode.toString().slice(0,2) === "99" && relatedSellerPOItem.HSNCode.toString().length === 6){
                        serviceExists = true
                    } else {
                        goodsExists = true
                    }
                })
                if(serviceExists && goodsExists){
                    isPIWithBothServiceAndGoodsExists = true
                } else {
                    isPIWithOnlyServicesOrOnlyGoodsExists = true
                }
            }
        })
    }

    if(services.length && !goods.length){
        isAllItemsAreServices = true
    }
    if(!services.length && goods.length){
        isAllItemsAreGoods = true
    }

    if(sellerPODetails.sellerPO.logisticsBeforeTax){
        sellerPOTotalPriceBeforeTax += sellerPODetails.sellerPO.logisticsBeforeTax
        sellerPOMaterialsTotalPriceBeforeTax += sellerPODetails.sellerPO.logisticsBeforeTax
        sellerPOTotalTax += (sellerPODetails.sellerPO.logisticsWithTax - sellerPODetails.sellerPO.logisticsBeforeTax)
        sellerPOTotalPrice += sellerPODetails.sellerPO.logisticsWithTax

        if(sellerPODetails.sellerPO.logisticsTDSSection){
            totalTDSAmount += sellerPODetails.sellerPO.logisticsTDSSection * 0.01
        }
    }

    totalTDSAmount += totalItemTDSAmount

    let relatedSellerCompanyDetails = sellerPODetails.sellerComapanyDetails

    if(sellerPODetails.sellerPO.tdsSectionId){
        let serviceTDSValue = 0
        let goodsTDSValue = 0

        if(services.length){
            const relatedServiceTDSSection = sellerPODetails.tdsSections.find(eachSection => eachSection.tdsSectionId === relatedSellerCompanyDetails.tdsSectionId)
            
            if (relatedServiceTDSSection && relatedSellerCompanyDetails.panCode && relatedSellerCompanyDetails.panCode[3] === "P"){
                serviceTDSValue = relatedServiceTDSSection.individualTDSRate
            } else if(relatedServiceTDSSection) {
                serviceTDSValue = relatedServiceTDSSection.othersTDSRate
            }
            servicesTDSAmount = servicesTotalPriceBeforeTax * serviceTDSValue * 0.01
        }
        if(goods.length){
            goodsTDSValue = 0
            if(sellerPODetails.sellerComapanyDetails.tdsSection194q){
                goodsTDSAmount = goodsTotalPriceBeforeTax * 0.1 * 0.01
                goodsTDSValue = 0.1
            }
        }

        TDSAmountIfServicesWerePunchedSeperately += servicesTDSAmount + goodsTDSAmount
        TDSAmountIfServicesWerePunchedTogeather += (sellerPOTotalItemAmountBeforeTax * serviceTDSValue) * 0.01

        if(sellerPODetails.sellerPO.logisticsBeforeTax){
            if(services.length){
                TDSAmountIfServicesWerePunchedSeperately += sellerPODetails.sellerPO.logisticsBeforeTax * 0.01 * serviceTDSValue
                TDSAmountIfServicesWerePunchedTogeather += sellerPODetails.sellerPO.logisticsBeforeTax * 0.01 * serviceTDSValue
            } else {
                TDSAmountIfServicesWerePunchedSeperately += sellerPODetails.sellerPO.logisticsBeforeTax * 0.01 * goodsTDSValue
                TDSAmountIfServicesWerePunchedTogeather += sellerPODetails.sellerPO.logisticsBeforeTax * 0.01 * goodsTDSValue
            }
        }

        if(services.length){
            totalTDSAmount = TDSAmountIfServicesWerePunchedTogeather
        } else {
            totalTDSAmount = TDSAmountIfServicesWerePunchedSeperately
        }

        if(isPIWithBothServiceAndGoodsExists){
            totalTDSAmount = TDSAmountIfServicesWerePunchedTogeather
        }

        if(isPIWithOnlyServicesOrOnlyGoodsExists){
            totalTDSAmount = TDSAmountIfServicesWerePunchedSeperately
        }
    }

    sellerPOTotalTax = round(sellerPOTotalTax)
    sellerPOTotalPriceBeforeTax = round(sellerPOTotalPriceBeforeTax)
    sellerPOTotalPrice = round(sellerPOTotalPrice)

    /*if(sellerPODetails.sellerPO.tdsSectionId && !advanceTDSVendorPayment){
        if(services.length && ![1, 8].includes(relatedSellerCompanyDetails.tdsSectionId)){
            sellerPODetails.sellerPO.tdsSectionId = relatedSellerCompanyDetails.tdsSectionId
            const relatedTDSSection = sellerPODetails.tdsSections.find(eachSection => eachSection.tdsSectionId === relatedSellerCompanyDetails.tdsSectionId)
            if (relatedSellerCompanyDetails.panCode && relatedSellerCompanyDetails.panCode[3] === "P"){
                sellerPODetails.sellerPO.tdsValue = relatedTDSSection.individualTDSRate
            } else {
                sellerPODetails.sellerPO.tdsValue = relatedTDSSection.othersTDSRate
            }
        } else if(!services.length) {
            sellerPODetails.sellerPO.tdsSectionId = 8
            sellerPODetails.sellerPO.tdsValue = 0

            if(sellerPODetails.sellerComapanyDetails.tdsSection194q){
                sellerPODetails.sellerPO.tdsSectionId = 1
                sellerPODetails.sellerPO.tdsValue = 0.1
            }
        }
    }

    if(sellerPODetails.sellerPO.tdsSectionId){ // tdsSection194q
        //console.log("555555555", sellerPODetails.sellerPO.tdsSectionId)
        totalTDSAmount = sellerPOTotalPriceBeforeTax * sellerPODetails.sellerPO.tdsValue * 0.01
        //console.log("555555555", totalTDSAmount, sellerPODetails.sellerPO, sellerPODetails.sellerPO.tdsValue, sellerPODetails.sellerPO.tdsValue * 0.01)
        materialsTotalTDSAmount = sellerPOMaterialsTotalPriceBeforeTax * sellerPODetails.sellerPO.tdsValue * 0.01

        if(sellerPODetails.sellerComapanyDetails.tdsSection194q){
            materialsTotalTDSAmount = sellerPOMaterialsTotalPriceBeforeTax * 0.1 * 0.01
        }
    }*/

    let lastPaymentTerm = ""
    let payAdvPOAmount = 0
    let payAdvDeliveryAmount = 0
    let payPDCDeliveryAmount = 0
    let payOnDeliveryAmount = 0
    let payCreditAmount = 0

    let sellerPOPaymentTerms = sellerPODetails.sellerPO.paymentTerms

    if(sellerPOPaymentTerms.payAdvPO){
        payAdvPOAmount = round(sellerPOPaymentTerms.payAdvPO * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
        lastPaymentTerm = "payAdvPO"
    }
    if(sellerPOPaymentTerms.payAdvDelivery){
        payAdvDeliveryAmount = round(sellerPOPaymentTerms.payAdvDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
        lastPaymentTerm = "payAdvDelivery"
    }
    if(sellerPOPaymentTerms.payPDCDelivery){
        payPDCDeliveryAmount = round(sellerPOPaymentTerms.payPDCDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
        lastPaymentTerm = "payPDCDelivery"
    }
    if(sellerPOPaymentTerms.payOnDelivery){
        payOnDeliveryAmount = round(sellerPOPaymentTerms.payOnDelivery * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
        lastPaymentTerm = "payOnDelivery"
    }
    if(sellerPOPaymentTerms.payCredit){
        payCreditAmount = round(sellerPOPaymentTerms.payCredit * sellerPODetails.sellerPO.totalItemAmountBeforeTax/100, 2)
        lastPaymentTerm = "payCredit"
    }


    if(lastPaymentTerm === "payAdvPO"){
        payAdvPOAmount = round(payAdvPOAmount + sellerPOTotalTax)
    }
    if(lastPaymentTerm === "payAdvDelivery"){
        payAdvDeliveryAmount = round(payAdvDeliveryAmount + sellerPOTotalTax)
    }
    if(lastPaymentTerm === "payPDCDelivery"){
        payPDCDeliveryAmount = round(payPDCDeliveryAmount + sellerPOTotalTax)
    }
    if(lastPaymentTerm === "payOnDelivery"){
        payOnDeliveryAmount = round(payOnDeliveryAmount + sellerPOTotalTax)
    }
    if(lastPaymentTerm === "payCredit"){
        payCreditAmount = round(payCreditAmount + sellerPOTotalTax)
    }

    let actualPayAdvPOAmount = 0
    let actualPayAdvDeliveryAmount = 0
    let actualPayPDCDeliveryAmount = 0
    let actualPayOnDeliveryAmount = 0
    let actualPayCreditAmount = 0

    let termWiseTotalPaymentAmount = 0
    let actualTermWiseTotalPaymentAmount = 0

    let termDifference = 0

    if(payAdvPOAmount){
        termWiseTotalPaymentAmount += payAdvPOAmount
        if(sellerPOAdvancePOPaymentRequestedAmount > payAdvPOAmount){
            actualPayAdvPOAmount = sellerPOAdvancePOPaymentRequestedAmount
            termDifference = sellerPOAdvancePOPaymentRequestedAmount - payAdvPOAmount
        } else {
            actualPayAdvPOAmount = payAdvPOAmount
        }
        actualTermWiseTotalPaymentAmount += actualPayAdvPOAmount
    }
    if(payAdvDeliveryAmount){
        termWiseTotalPaymentAmount += payAdvDeliveryAmount
        if(termWiseTotalPaymentAmount > actualTermWiseTotalPaymentAmount + sellerPOAdvancePaymentRequestedAmount){
            actualPayAdvDeliveryAmount = payAdvDeliveryAmount - termDifference
            if(actualPayAdvDeliveryAmount < 0){
                termDifference = Math.abs(actualPayAdvDeliveryAmount)
                actualPayAdvDeliveryAmount = 0
            } else {
                termDifference = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayAdvDeliveryAmount
        } else {
            if(sellerPOAdvancePaymentRequestedAmount >= payAdvDeliveryAmount){
                actualPayAdvDeliveryAmount = sellerPOAdvancePaymentRequestedAmount
                actualTermWiseTotalPaymentAmount += actualPayAdvDeliveryAmount
                termDifference = termDifference + sellerPOAdvancePaymentRequestedAmount - payAdvDeliveryAmount
            } else {
                actualPayAdvDeliveryAmount = payAdvDeliveryAmount - termDifference
                if(actualPayAdvDeliveryAmount < sellerPOAdvancePaymentRequestedAmount){
                    actualPayAdvDeliveryAmount = sellerPOAdvancePaymentRequestedAmount
                }
                if(actualPayAdvDeliveryAmount < 0){
                    actualPayAdvDeliveryAmount = 0
                }
                actualTermWiseTotalPaymentAmount += actualPayAdvDeliveryAmount
                termDifference = actualTermWiseTotalPaymentAmount - termWiseTotalPaymentAmount
                if(termDifference < 0){
                    termDifference = 0
                }
            }
        }
    }
    if(payPDCDeliveryAmount){
        termWiseTotalPaymentAmount += payPDCDeliveryAmount
        if(termWiseTotalPaymentAmount > actualTermWiseTotalPaymentAmount + sellerPOPDCOnDeliveryPaymentRequestedAmount){
            actualPayPDCDeliveryAmount = payPDCDeliveryAmount - termDifference
            if(actualPayPDCDeliveryAmount < 0){
                termDifference = Math.abs(actualPayPDCDeliveryAmount)
                actualPayPDCDeliveryAmount = 0
            } else {
                termDifference = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayPDCDeliveryAmount
        } else {
            if(sellerPOPDCOnDeliveryPaymentRequestedAmount >= payPDCDeliveryAmount){
                actualPayPDCDeliveryAmount = sellerPOPDCOnDeliveryPaymentRequestedAmount
                actualTermWiseTotalPaymentAmount += actualPayPDCDeliveryAmount
                termDifference = termDifference + sellerPOPDCOnDeliveryPaymentRequestedAmount - payPDCDeliveryAmount
            } else {
                actualPayPDCDeliveryAmount = payPDCDeliveryAmount - termDifference
                if(actualPayPDCDeliveryAmount < sellerPOPDCOnDeliveryPaymentRequestedAmount){
                    actualPayPDCDeliveryAmount = sellerPOPDCOnDeliveryPaymentRequestedAmount
                }
                if(actualPayPDCDeliveryAmount < 0){
                    actualPayPDCDeliveryAmount = 0
                }
                actualTermWiseTotalPaymentAmount += actualPayPDCDeliveryAmount
                termDifference = actualTermWiseTotalPaymentAmount - termWiseTotalPaymentAmount
                if(termDifference < 0){
                    termDifference = 0
                }
            }
        }
    }
    if(payOnDeliveryAmount){
        termWiseTotalPaymentAmount += payOnDeliveryAmount

        if(termWiseTotalPaymentAmount > actualTermWiseTotalPaymentAmount){
            actualPayOnDeliveryAmount = payOnDeliveryAmount - termDifference
            if(actualPayOnDeliveryAmount < 0){
                termDifference = Math.abs(actualPayOnDeliveryAmount)
                actualPayOnDeliveryAmount = 0
            } else {
                termDifference = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayOnDeliveryAmount
        } else {
            actualPayOnDeliveryAmount = payOnDeliveryAmount - termDifference
            if(actualPayOnDeliveryAmount < 0){
                actualPayOnDeliveryAmount = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayOnDeliveryAmount
            termDifference = actualTermWiseTotalPaymentAmount - termWiseTotalPaymentAmount
            if(termDifference < 0){
                termDifference = 0
            }
        }
    }

    if(payCreditAmount){
        termWiseTotalPaymentAmount += payCreditAmount

        if(termWiseTotalPaymentAmount > actualTermWiseTotalPaymentAmount){
            actualPayCreditAmount = payCreditAmount - termDifference
            if(actualPayCreditAmount < 0){
                termDifference = Math.abs(actualPayCreditAmount)
                actualPayCreditAmount = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayCreditAmount
        } else {
            actualPayCreditAmount = payCreditAmount - termDifference
            if(actualPayCreditAmount < 0){
                actualPayCreditAmount = 0
            }
            actualTermWiseTotalPaymentAmount += actualPayCreditAmount
            termDifference = actualTermWiseTotalPaymentAmount - termWiseTotalPaymentAmount
            if(termDifference < 0){
                termDifference = 0
            }
        }
    }

    let actualPayAdvPO = 0
    let actualPayAdvDelivery = 0
    let actualPayPDCDelivery = 0
    let actualPayOnDelivery = 0
    let actualPayCredit = 0

    if(actualPayAdvPOAmount){
        actualPayAdvPO = (actualPayAdvPOAmount / sellerPOTotalPrice) * 100
    }
    if(actualPayAdvDeliveryAmount){
        actualPayAdvDelivery = (actualPayAdvDeliveryAmount / sellerPOTotalPrice) * 100
    }
    if(actualPayPDCDeliveryAmount){
        actualPayPDCDelivery = (actualPayPDCDeliveryAmount / sellerPOTotalPrice) * 100
    }
    if(actualPayOnDeliveryAmount){
        actualPayOnDelivery = (actualPayOnDeliveryAmount / sellerPOTotalPrice) * 100
    }
    if(actualPayCreditAmount){
        actualPayCredit = (actualPayCreditAmount / sellerPOTotalPrice) * 100
    }

    return {
        sellerPOTotalPriceBeforeTax: sellerPOTotalPriceBeforeTax,
        sellerPOTotalPrice: sellerPOTotalPrice,
        sellerPOTotalTax: sellerPOTotalTax,
        grandTotalPrice: sellerPOTotalPrice,
        totalTDSAmount: round(totalTDSAmount),
        materialsTotalTDSAmount: round(materialsTotalTDSAmount),
        sellerPOMaterialsTotalPriceBeforeTax: sellerPOMaterialsTotalPriceBeforeTax,
        TDSAmountIfServicesWerePunchedSeperately: round(TDSAmountIfServicesWerePunchedSeperately),
        TDSAmountIfServicesWerePunchedTogeather: round(TDSAmountIfServicesWerePunchedTogeather),
        //roundOff: round_off,

        isPIWithBothServiceAndGoodsExists: isPIWithBothServiceAndGoodsExists,
        isPIWithOnlyServicesOrOnlyGoodsExists: isPIWithOnlyServicesOrOnlyGoodsExists,

        actualPayAdvPOAmount: round(actualPayAdvPOAmount),
        actualPayAdvDeliveryAmount: round(actualPayAdvDeliveryAmount),
        actualPayPDCDeliveryAmount: round(actualPayPDCDeliveryAmount),
        actualPayOnDeliveryAmount: round(actualPayOnDeliveryAmount),
        actualPayCreditAmount: round(actualPayCreditAmount),

        payAdvPORequestedAmount: round(payAdvPORequestedAmount),
        payAdvDeliveryRequestedAmount: round(payAdvDeliveryRequestedAmount),
        payPDCDeliveryRequestedAmount: round(payPDCDeliveryRequestedAmount),
        payOnDeliveryRequestedAmount: round(payOnDeliveryRequestedAmount),
        payCreditRequestedAmount: round(payCreditRequestedAmount),

        actualPayAdvPO: actualPayAdvPO,
        actualPayAdvDelivery: actualPayAdvDelivery,
        actualPayPDCDelivery: actualPayPDCDelivery,
        actualPayOnDelivery: actualPayOnDelivery,
        actualPayCredit: actualPayCredit,

        sellerPODate: sellerPODetails.sellerPO.createdAt
    }
}

export const calculateDispatchNote = (dispatchNote, dispatchNoteItems) => {
    let totalAmountBeforeTax = 0
    let totalAmountWithTax = 0
    let totalDispatchTax = 0
    const updatedDispatchNoteItems = dispatchNoteItems?.map(eachDispatchNoteItem => {
        let priceBeforeTax = 0
        let totalTax = 0
        let priceAfterTax = 0
        if (eachDispatchNoteItem?.qty){
            priceBeforeTax += eachDispatchNoteItem?.qty * eachDispatchNoteItem?.unitPrice
            totalTax += priceBeforeTax * eachDispatchNoteItem?.GSTRate * 0.01
            priceAfterTax += priceBeforeTax + totalTax
        }
        totalAmountBeforeTax += priceBeforeTax
        totalAmountWithTax += priceAfterTax
        totalDispatchTax += totalTax 
        return ({...eachDispatchNoteItem, itemAmountBeforeTax : priceBeforeTax, itemAmountWithTax : priceAfterTax})
    })
    let totalAmount = parseInt(totalAmountWithTax)
    return {
        dispatchNote: {
            ...dispatchNote, 
            totalAmountBeforeTax : round(totalAmountBeforeTax, DECIMAL_LIMIT), 
            totalAmountWithTax : round(totalAmountWithTax, DECIMAL_LIMIT), 
            totalAmount : round(totalAmount, DECIMAL_LIMIT),
            totalTax : round(totalDispatchTax, DECIMAL_LIMIT)
        },
        dispatchNoteItems : updatedDispatchNoteItems
    }
}

export const calculateBuyerInvoice = (buyerInvoice, buyerInvoiceItems) => {
    let totalAmountBeforeTax = 0
    let totalInvTax = 0 
    let totalAmountWithTax = 0

    let logisticsBeforeTax = 0
    let logisticsTax = 0
    let logisticsWithTax = 0

    let gstRateArr = []

    const updatedBuyerInvoiceItems = buyerInvoiceItems?.map(eachBuyerInvoiceItem => {
        let priceBeforeTax = 0
        let totalTax = 0
        let priceAfterTax = 0

        if (eachBuyerInvoiceItem?.qty){
            priceBeforeTax += eachBuyerInvoiceItem?.qty * eachBuyerInvoiceItem?.unitPrice
            totalTax += priceBeforeTax * eachBuyerInvoiceItem?.GSTRate * 0.01
            priceAfterTax += parseFloat(totalTax)
        }

        if(priceBeforeTax){
            totalAmountBeforeTax = totalAmountBeforeTax + priceBeforeTax
        }
        if(totalTax){
            totalInvTax = totalInvTax + totalTax
        }
        gstRateArr.push(eachBuyerInvoiceItem?.GSTRate)


        return {...eachBuyerInvoiceItem, itemAmountBeforeTax : priceBeforeTax, itemAmountWithTax : priceAfterTax}
    })

    gstRateArr = _.uniqBy(gstRateArr)

    const maxGstRate = _.max(gstRateArr)

    if(buyerInvoice?.logisticsBeforeTax){
        logisticsBeforeTax = buyerInvoice?.logisticsBeforeTax
        logisticsTax = logisticsBeforeTax * maxGstRate * 0.01
        logisticsWithTax = logisticsBeforeTax + logisticsTax
    }

    totalAmountWithTax = totalAmountBeforeTax + totalInvTax
    buyerInvoice.totalAmountBeforeTax = round(parseFloat(totalAmountBeforeTax) + parseFloat(logisticsBeforeTax))
    buyerInvoice.totalInvTax = round(parseFloat(totalInvTax) + parseFloat(logisticsTax))
    buyerInvoice.totalAmountWithTax = round(parseFloat(totalAmountWithTax) + parseFloat(logisticsWithTax))
    buyerInvoice.totalInvAmount = _.round(buyerInvoice.totalAmountWithTax)

    buyerInvoice.logisticsBeforeTax = logisticsBeforeTax
    buyerInvoice.logisticsWithTax = logisticsWithTax
    buyerInvoice.logisticsGSTRate = maxGstRate
    return {
        buyerInvoice : {...buyerInvoice},
        buyerInvoiceItems : updatedBuyerInvoiceItems
    }
}

export const calculateBuyerAdjustmentNote = (adjustmentNote, adjustmentNoteItems, buyerInvoice, buyerInvoiceItems) => {
    let productDetails = []
    let totalAmountBeforeTax = 0
    let totalAmountWithTax = 0
    let totalInvAmount = 0
    let totalInvTax = 0

    adjustmentNoteItems?.map(eachAdjustmentNoteItem => {
        const relatedBuyerInvoiceItem = buyerInvoiceItems?.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceItemId === eachAdjustmentNoteItem?.buyerInvoiceItemId)

        let itemAmountBeforeTax = eachAdjustmentNoteItem?.adjustedQty * relatedBuyerInvoiceItem?.unitPrice
        let itemAmountWithTax = itemAmountBeforeTax + itemAmountBeforeTax * relatedBuyerInvoiceItem?.GSTRate * 0.01

        let newProduct = {
            materialId: relatedBuyerInvoiceItem?.materialId,
            HSNCode: relatedBuyerInvoiceItem?.HSNCode,
            qty: eachAdjustmentNoteItem?.adjustedQty,
            unitPrice: relatedBuyerInvoiceItem?.unitPrice,
            itemAmountBeforeTax: itemAmountBeforeTax,
            itemTax: parseFloat(itemAmountBeforeTax * relatedBuyerInvoiceItem?.GSTRate * 0.01),
            itemAmountWithTax: itemAmountWithTax,
            GSTRate: relatedBuyerInvoiceItem?.GSTRate,
            buyerReqItemId: relatedBuyerInvoiceItem?.buyerReqItemId
        }
        totalAmountBeforeTax += itemAmountBeforeTax
        totalAmountWithTax += itemAmountWithTax
        totalInvTax += (itemAmountWithTax - itemAmountBeforeTax)
        productDetails.push(newProduct)
    })
    let updatedAdjustmentNote = {
        docNo: adjustmentNote?.docNo,
        fileNo: adjustmentNote?.fileNo,
        pmBillAddrId: buyerInvoice?.pmBillAddrId,
        billAddrId: buyerInvoice?.billAddrId,
        shipAddrId: buyerInvoice?.shipAddrId,
        adjustmentNoteId: adjustmentNote?.adjustmentNoteId
    }
    updatedAdjustmentNote.totalAmountBeforeTax = totalAmountBeforeTax
    updatedAdjustmentNote.totalAmountWithTax = totalAmountWithTax
    updatedAdjustmentNote.totalInvAmount = parseInt(totalAmountWithTax)
    updatedAdjustmentNote.totalInvTax = round(totalAmountWithTax - totalAmountBeforeTax)

    return {adjustmentNote: updatedAdjustmentNote, adjustmentNoteItems: productDetails}
}

export const getCompanyShortName = (companyName) => {
    if(companyName){
        let companyShortNameArr = companyName.split(' ')
        let companyShortName = companyShortNameArr.slice(0, 2).join(" ")

        return companyShortName
    }
} 

export const getManagerIds = (userId, pmBranchId, companyUsers) => {
    // const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
    let managerId = null
    if(companyUsers?.length){
        companyUsers.map(eachCompanyUser => {
            if(eachCompanyUser.statusId === 1 && eachCompanyUser.userId === userId){
                eachCompanyUser.userRoles.map(eachUserRole => {
                    if(pmBranchId && eachUserRole.branchId === pmBranchId && eachUserRole.statusId === 1){
                        managerId = eachUserRole.managerId
                    }
                })
            }
        })
    }
    return [managerId]
} 

export const getBranchComparision = (userBranchId, pmBranchId) => {
    if (userBranchId === pmBranchId || userBranchId === 0){
        return true
    }
}

export const getKeysTransformedToValuesObject = (originalObj) => {
    const transformedObj = {}

    Object.keys(originalObj).forEach(key => {
        const values = originalObj[key]
        
        values.forEach(value => {
            transformedObj[value] = parseInt(key)
        })
    })
    return transformedObj
}

export const getValuesTransformedToKeysObject = (originalObj) => {
    const transformedObj = {}

    Object.entries(originalObj).forEach(([key, value]) => {
        if (!transformedObj[value]) {
            transformedObj[value] = []
        }
    
        transformedObj[value].push(parseInt(key))
    })

    return transformedObj
}

export const getListDiscountAndUnitPrices = (name, listPrice, discount, unitPrice) => {
    if (name === "contractPrice"){
        if (listPrice > 0 && unitPrice < listPrice){
            const relatedDiscountRate = ((listPrice - unitPrice)/listPrice) * 100
            return {listPrice: listPrice, unitPrice : unitPrice, discount : (round(relatedDiscountRate, 2))}
        }else{
            let relatedListPrice = round(unitPrice /(1 - discount * 0.01))
            return {listPrice: relatedListPrice, unitPrice: unitPrice, discount: discount}
        }
    }else if (name === "discount"){
        if (listPrice){
            const relatedUnitPrice = round((listPrice - (listPrice* discount * 0.01)), 2)
            return {listPrice: listPrice, discount : discount, unitPrice : round(relatedUnitPrice, 2)}
        }else{
            let relatedListPrice = round(unitPrice /(1 - discount * 0.01))
            return {unitPrice: unitPrice, discount: discount, listPrice: relatedListPrice}
        }
    }else if (name === "listPrice" && listPrice >= 0){
        if (listPrice === 0){
            return {listPrice : listPrice, unitPrice : 0, discount: 0}
        }else{
            let relatedUnitPrice = listPrice - listPrice * discount * 0.01
            return {listPrice: listPrice, discount: discount, unitPrice: round(relatedUnitPrice)}
        }
    }
}

export const generateReplacedProducts2 = (buyerInvoiceItems, docReplacementItems) => {
    console.log("entered55")

    console.log("entered65")
}

export const generateReplacedProducts = (buyerInvoiceItems, docReplacementItems, materialUOMs) => {
    console.log("entered 11", buyerInvoiceItems, docReplacementItems)

    buyerInvoiceItems = JSON.parse(JSON.stringify(buyerInvoiceItems))

    const replacedBuyerInvoiceIds = docReplacementItems.map(eachReplacementItem => eachReplacementItem.docId)
    console.log("replacedBuyerInvoiceIds", replacedBuyerInvoiceIds, docReplacementItems)

    buyerInvoiceItems = buyerInvoiceItems.map(eachInvoiceItem => {
        const relatedDocItemReplacementLogMaterial = docReplacementItems?.find(eachReplaceLogItem => eachReplaceLogItem?.docId === eachInvoiceItem?.buyerInvoiceId && eachReplaceLogItem?.toReplace[eachInvoiceItem?.materialId])
        if(relatedDocItemReplacementLogMaterial){
            eachInvoiceItem.isReplacebleItem = true
        }
        return eachInvoiceItem
    })

    let replacedBuyerInvoiceItems = []
    let unreplacedBuyerInvoiceItems = []
    let replacedProducts = []
    
    docReplacementItems?.map(eachReplaceMapItem => {
        const relatedDocItemReplacementLog = eachReplaceMapItem
        const relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachInvItem => eachReplaceMapItem?.docId === eachInvItem?.buyerInvoiceId)

        relatedBuyerInvoiceItems.map(eachBuyerInvoiceItem => {
            let relatedMaterialReplacedQty = eachReplaceMapItem?.toReplace[eachBuyerInvoiceItem?.materialId]

            if (relatedMaterialReplacedQty){
                replacedBuyerInvoiceItems.push(eachBuyerInvoiceItem)
            } else{
                let existedUnReplacedProduct = unreplacedBuyerInvoiceItems.find(eachUnreplacedItem => eachUnreplacedItem.buyerReqItemId === eachBuyerInvoiceItem.buyerReqItemId && eachReplaceMapItem?.docId === eachUnreplacedItem?.buyerInvoiceId)
                if(!existedUnReplacedProduct && !eachBuyerInvoiceItem.isReplacebleItem){
                    unreplacedBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                }
            }
            
            if (relatedMaterialReplacedQty && relatedMaterialReplacedQty !== eachBuyerInvoiceItem?.qty){

                let existedUnReplacedProduct = unreplacedBuyerInvoiceItems.find(eachUnreplacedItem => eachUnreplacedItem.buyerReqItemId === eachBuyerInvoiceItem.buyerReqItemId && eachReplaceMapItem?.docId === eachUnreplacedItem?.buyerInvoiceId)
                if(existedUnReplacedProduct){
                    let unreplacedQty = parseFloat(existedUnReplacedProduct?.qty) - (parseFloat(relatedMaterialReplacedQty) * relatedDocItemReplacementLog?.qtyReplaced)
                    
                    let itemAmountBeforeTax = parseFloat(unreplacedQty) * parseFloat(eachBuyerInvoiceItem?.unitPrice)
                    eachBuyerInvoiceItem.qty = unreplacedQty
                    existedUnReplacedProduct.qty = unreplacedQty
                    existedUnReplacedProduct.itemAmountBeforeTax = itemAmountBeforeTax
                    existedUnReplacedProduct.itemAmountWithTax = itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                    eachBuyerInvoiceItem = {
                        ...existedUnReplacedProduct, 
                        qty: unreplacedQty,
                        itemAmountBeforeTax: itemAmountBeforeTax,
                        itemAmountWithTax:   itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                    }
                } else {
                    let unreplacedQty = parseFloat(eachBuyerInvoiceItem?.qty) - (parseFloat(relatedMaterialReplacedQty) * relatedDocItemReplacementLog?.qtyReplaced)
                    
                    let itemAmountBeforeTax = parseFloat(unreplacedQty) * parseFloat(eachBuyerInvoiceItem?.unitPrice)
                    eachBuyerInvoiceItem.qty = unreplacedQty
                    eachBuyerInvoiceItem = {
                        ...eachBuyerInvoiceItem, 
                        qty: unreplacedQty,
                        itemAmountBeforeTax: itemAmountBeforeTax,
                        itemAmountWithTax:   itemAmountBeforeTax + (itemAmountBeforeTax * parseFloat(eachBuyerInvoiceItem?.GSTRate) * 0.01)
                    }
                    unreplacedBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                }
                
            }
        })
        let itemAmountBeforeTax = parseFloat(relatedDocItemReplacementLog?.qtyReplaced) * parseFloat(relatedDocItemReplacementLog?.unitPrice)
        replacedProducts.push(
            {
                ...relatedBuyerInvoiceItems[0],
                buyerInvoiceId: null,
                buyerInvoiceItemId: null,
                productName : eachReplaceMapItem?.replaceByName,
                productSpecification : eachReplaceMapItem?.replaceByDesc,
                HSNCode : eachReplaceMapItem?.HSNCode,
                materialId: null,
                listPrice: relatedDocItemReplacementLog?.unitPrice,
                unitPrice: relatedDocItemReplacementLog?.unitPrice,
                GSTRate: relatedDocItemReplacementLog?.GSTRate,
                qty: relatedDocItemReplacementLog?.qtyReplaced,
                UOM: eachReplaceMapItem?.UOM,
                itemAmountBeforeTax: itemAmountBeforeTax,
                itemAmountWithTax: itemAmountBeforeTax + itemAmountBeforeTax * parseFloat(relatedDocItemReplacementLog?.GSTRate) * 0.01,
                isReplaced: true
            }
        )
    })

    /*if (!docReplacementItems?.length){
        unreplacedBuyerInvoiceItems = buyerInvoiceItems
    }*/
    
    let unreplacedProducts = []
    unreplacedBuyerInvoiceItems?.map(eachInvoiceItem => {
        const buyerInvoiceItemRelatedMap = docReplacementItems?.find(eachReplaceMapItem => Object.keys(eachReplaceMapItem.toReplace).includes(eachInvoiceItem?.materialId?.toString()))

        let isItemCanBeAdded = false
        if (!buyerInvoiceItemRelatedMap && eachInvoiceItem?.qty > 0){
            isItemCanBeAdded = true
        }
        if (eachInvoiceItem?.qty > 0.05 || isItemCanBeAdded){
            unreplacedProducts.push(eachInvoiceItem)
        }
    })

    buyerInvoiceItems.map(eachBuyerInvoiceItem => {
        if(!replacedBuyerInvoiceIds.includes(eachBuyerInvoiceItem.buyerInvoiceId)){
            unreplacedProducts.push(eachBuyerInvoiceItem)
        }
    })

    buyerInvoiceItems = [...unreplacedProducts, ...replacedProducts]
    
    return buyerInvoiceItems
}

export const calculateBuyerInvoiceWithReplaceProducts = () => {
    
}

/*export const getMatchedRegexPattern = (text, availableOptions) => {
    const patterns = [
        {
            name: 'docNo',
            regex: /^\d{11}$|^\d{15}$|^\d{16}$/,
        },
        {
            name: 'fileNo',
            regex: /^\d{8}$/,
        },
        {
            name: 'pan',
            regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        },
        {
            name: 'gstin',
            regex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/,
        },
        {
            name: 'alphabet',
            regex: /^[()a-zA-Z ]+$/,
        },
        {
            name: 'phoneNumber',
            regex: /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
        },
        {
            name: 'email',
            regex: /^[a-zA-Z0-9_.±]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/
        },
        {
            name: 'materialId',
            regex: /^[789]\d{6}$|^[12]\d{5}$/
        }
    ]

    let matchedPattern
    if (availableOptions && availableOptions.length > 0) {
        matchedPattern = patterns.find(pattern => availableOptions.includes(pattern.name) && pattern.regex.test(text))
    } else {
        matchedPattern = patterns.find(pattern => pattern.regex.test(text))
    }

    if (matchedPattern) {
        return matchedPattern.name
    } else {
        return "all"
    }
}*/

export const getMatchedRegexPattern = (text, availableOptions, currentOption) => {
    const assets = [
        { name: 'pan', regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/ },
        { name: 'gstin', regex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/ },
        { name: 'userEmail', regex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ },
        { name: 'email', regex: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ },
        { name: 'materialId', regex: /^[89]\d{6}$|^[127]\d{5}$/ },
        { name: 'docNo', regex: /^[\d\/\\]{9,}$/ }, // /^\d{11}$|^\d{15}$|^\d{16}$/
        { name: 'ticketId', regex: /^\d{5,6}$/ },
        { name: 'fileNo', regex: /^\d{8}$/ },
        { name: 'phoneNumber', regex: /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/ }
    ]

    let liabilities = [
        { name: 'kamName', regex: /^(?=.{3,})[a-zA-Z]+(?:\s+[a-zA-Z]+){0,2}\s?$/ },
        { name: 'userName', regex: /^(?=.{3,})[a-zA-Z]+(?:\s+[a-zA-Z]+){0,2}\s?$/ }, //  /^[a-zA-Z ]{2,30}$/
        { name: 'companyName', regex: /^(?!\d+$)[a-zA-Z0-9&.,\- ]{3,100}$/ } // /^[a-zA-Z0-9&.,\- ]{3,100}$/
    ]

    if(availableOptions){
        const sortedOptionNames = _.map(_.sortBy(_.filter(availableOptions, o => _.has(o, 'priority')), 'priority'), 'name')
        if(sortedOptionNames.length > 0){
            liabilities = _.sortBy(liabilities, o => _.indexOf(sortedOptionNames, o.name))
        }
    }

    const patterns = [...assets, ...liabilities]

    if(currentOption && currentOption !== "all"){
        const relatedPattern = patterns.find(eachPattern => eachPattern.name === currentOption)
        if(relatedPattern){
            const isCurrentPatternMatched = relatedPattern.regex.test(text)
            if(isCurrentPatternMatched){
                return currentOption
            }
        } else {
            if(!text){
                return "all"
            }
            return currentOption
        }
    }

    const regexMap = new Map()
    patterns.forEach(({ name, regex }) => regexMap.set(name, regex))

    let matchedPattern = "all"
    const availableOptionsNames = availableOptions ? availableOptions.map(eachOption => eachOption.name) : []

    for (const [name, regex] of regexMap) {
        if ((!availableOptions || availableOptionsNames.includes(name)) && regex.test(text)) {
            matchedPattern = name
            break
        }
    }

    return matchedPattern
}

export const createFuseSearch = (data, fieldName) => {
    return new Fuse(data, {
        keys: [fieldName],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true
    })
}

export const useFuzzSearch = (data, fieldName) => {
    const fuse = useCallback(() => createFuseSearch(data, fieldName), [data, fieldName])

    return useCallback(
        (searchText) => {
            const fuseInstance = fuse()
            return fuseInstance.search(searchText)
        },
        [fuse]
    )
}

export const getDateRange = (range) => {
    const today = new Date()
    let fromDate, toDate

    switch (range) {
        case 'MTD':
            fromDate = new Date(today.getFullYear(), today.getMonth(), 1)
            toDate = today
            break
        case 'PM':
            fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1)
            toDate = new Date(today.getFullYear(), today.getMonth(), 1)
            break
        case 'L15':
            fromDate = new Date(today.setDate(today.getDate() - 15))
            toDate = new Date()
            break
        case 'L30':
            fromDate = new Date(today.setDate(today.getDate() - 30))
            toDate = new Date()
            break
        default:
            fromDate = null
            toDate = null
            break
    }

    if(toDate){
        toDate.setHours(23, 59, 0, 0)
    }
    if(fromDate){
        fromDate.setHours(0, 0, 0, 0)
    }

    return { fromDate, toDate }
}

export const getAutoSearchSuggestions = ({
    searchType,
    query,
    pmCompanyUsers,
    buyerCompaniesUsers,
    buyerCompanies,
    kamFuzzSearch,
    buyerNameFuzzSearch,
    companyFuzzSearch
}) => {
    let suggestions = []

    switch (searchType) {
        case "kamName":
            if (query === "") {
                suggestions = [...pmCompanyUsers]
            } else {
                const searchResults = kamFuzzSearch(query)
                suggestions = searchResults.map(result => result.item)
            }
            break
        case "buyerName":
            if (query === "") {
                suggestions = [...buyerCompaniesUsers]
            } else {
                const searchResults = buyerNameFuzzSearch(query)
                suggestions = searchResults.map(result => result.item)
            }
            break
        case "companyName":
            if (query === "") {
                suggestions = [...buyerCompanies]
            } else {
                const searchResults = companyFuzzSearch(query)
                suggestions = searchResults.map(result => result.item)
            }
            break
        default:
            break
    }

    return suggestions
}

export const combineISDCodeWithPhoneNumber = (ISDCode, phoneNumber) => {
    let numericISDCode = ISDCode ? ISDCode.replace(/\D/g, '') : ""
    return `${numericISDCode}${phoneNumber.trim()}`
}

export const extractISDAndPhoneNumber = (phoneNumber) => {
    if (!phoneNumber.startsWith('+')) {
        phoneNumber = '+' + phoneNumber
    }

    let ISDCode = phoneNumber.slice(0, 3)
    let strippedPhoneNumber = phoneNumber.slice(3)

    return {
        ISDCode: ISDCode,
        phoneNumber: strippedPhoneNumber
    }
}

export const phoneNumberWithISDCode = (phoneNumber) => {
    let ISDCode = phoneNumber.slice(0, phoneNumber.length - 10)

    if (ISDCode && !ISDCode.startsWith('+')) {
        phoneNumber = '+' + phoneNumber
    }

    return phoneNumber
}

export const isMobile = () => {
    const userAgentCheck = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    const screenWidthCheck = window.innerWidth <= 768
    return userAgentCheck || screenWidthCheck
}

export const getApprovalStatus = (approvalRequestStatusDetails) => {
    let notRequestedApprovalExists = false
    let pendingApprovalsExist = false
    let allApprovalsApproved = false
    if(approvalRequestStatusDetails?.length){
        const pendingApprovalStatusDetails = approvalRequestStatusDetails.filter(eachReq => ["NOT REQUESTED", "REQUESTED", "REJECTED"].includes(eachReq.requestStatus))
        const notRequestedApprovalStatusDetails = approvalRequestStatusDetails.filter(eachReq => ["NOT REQUESTED"].includes(eachReq.requestStatus))
        const approvedApprovalStatusDetails = approvalRequestStatusDetails.filter(eachReq => eachReq.requestStatus === "APPROVED")

        if(pendingApprovalStatusDetails.length){
            pendingApprovalsExist = true
        }
        if(approvedApprovalStatusDetails.length === approvalRequestStatusDetails.length){
            allApprovalsApproved = true
        }
        if(notRequestedApprovalStatusDetails.length){
            notRequestedApprovalExists = true
        }
    }

    return {
        pendingApprovalsExist,
        allApprovalsApproved,
        notRequestedApprovalExists
    }
}

export const getTempBuyerQuoteItems = (buyerQuoteResponse, buyerReqItems, sellerReqItems, buyerQuoteItems, materialDetails) => {
    let deletedBuyerReqItems = []
    let allBuyerQuoteItems = []
    buyerReqItems.map(eachBuyerReqItem => {

        const relatedSellerReqItems = sellerReqItems.filter(eachSellerReqItem => {
            if (eachSellerReqItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachSellerReqItem.quotTotalAmountWithTax) {
                if (eachSellerReqItem.statusId === 2) {
                    const isSellerReqItemUsed = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.sellerReqItemId === eachSellerReqItem.sellerReqItemId && eachBuyerQuoteItem.statusId === 1)
                    if (isSellerReqItemUsed) {
                        return true
                    }
                } else {
                    return true
                }
            }
            return false
        })

        const relatedQuoteItem = buyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === eachBuyerReqItem.buyerReqItemId && eachBuyerQuoteItem.statusId === 1)
        if (!relatedQuoteItem) {
            deletedBuyerReqItems.push(eachBuyerReqItem.buyerReqItemId)
            return
        }

        const allSellerlistPrice = []
        relatedSellerReqItems.map(eachSellerReqItem => {
            if (eachSellerReqItem && !allSellerlistPrice.includes(eachSellerReqItem.quotListPrice)) {
                allSellerlistPrice.push(eachSellerReqItem.quotListPrice)
            }
        })

        const relatedMaterial = materialDetails.find(eachMaterialItem => eachMaterialItem.materialId === eachBuyerReqItem.materialId)
    
        relatedSellerReqItems.map(eachSellerReqItem => {
            let relatedBuyerQuoteItems = []

            const relatedBuyerQuoteItem = buyerQuoteItems.find(eachQuoteItem => {
                return eachQuoteItem.sellerReqItemId === eachSellerReqItem.sellerReqItemId
            })

            //const relatedCompanyWarehouse = companyWarehouses.find(eachWarehouse => eachWarehouse.shipAddrId === eachSellerReqItem?.shipAddrId)

            if (relatedBuyerQuoteItem) {
                const newBuyerQuoteItem = {
                    ...relatedBuyerQuoteItem,
                    bQuotSellerListPrice: eachSellerReqItem.quotListPrice,
                    bQuotSellerGSTRate: eachSellerReqItem.quotGSTRate,
                    sellerLeadTime: eachSellerReqItem.quotLeadTime,
                    printedDesc: relatedMaterial.productSpecification,
                    brandId: relatedMaterial.brandId,
                    categoryId: relatedMaterial.categoryId,
                    sellerQuoteQty: eachSellerReqItem.quotQty,
                    gstOptions: [],
                    sellerUnitLogistics: eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0,
                    isSellerReqExpired: eachSellerReqItem.statusId === 2 ? true : false,
                    maxLogisticGSTRate: null
                }
                newBuyerQuoteItem.sellerUnitPriceWithLogistics = newBuyerQuoteItem.bQuotSellerPrice + newBuyerQuoteItem.sellerUnitLogistics
                if (newBuyerQuoteItem.isSellerReqExpired) {
                    newBuyerQuoteItem.bQuotSellerQty = ""
                }
                relatedBuyerQuoteItems.push(newBuyerQuoteItem)
            } else {
                //If new seller req is added!
                const newBuyerQuoteItem = {
                    buyerQuoteItemId: uuidv4(),
                    buyerQuoteId: buyerQuoteResponse.buyerQuoteId,
                    buyerReqId: eachSellerReqItem.buyerReqId,
                    buyerReqItemId: eachSellerReqItem.buyerReqItemId,
                    sellerReqItemId: eachSellerReqItem.sellerReqItemId,
                    materialId: relatedMaterial.materialId,
                    printedDesc: relatedMaterial.productSpecification,
                    // companyERPCode: "",
                    totReqQty: relatedQuoteItem.totReqQty,
                    bQuotSellerQty: "",
                    bQuotSellerPrice: eachSellerReqItem.quotUnitPrice,
                    bQuotListPrice: allSellerlistPrice.length === 1 ? allSellerlistPrice[0] : null,
                    bQuotUnitPrice: relatedQuoteItem?.bQuotUnitPrice,
                    bQuotSellerDiscountRate: eachSellerReqItem.quotDiscountRate,
                    bQuotDiscountRate: relatedQuoteItem.bQuotDiscountRate,
                    bQuotMarginRate: relatedQuoteItem.bQuotMarginRate,
                    bQuoteGSTRate: null, //Keeping this null for now
                    bQuoteItemAmountBeforeTax: relatedQuoteItem?.bQuoteItemAmountBeforeTax,
                    bQuoteItemAmountWithTax: relatedQuoteItem?.bQuoteItemAmountWithTax,
                    bQuotHSNCode: relatedQuoteItem.bQuotHSNCode, //change
                    leadTime: relatedQuoteItem.leadTime,
                    statusId: 1,
                    buyerRateContractId: eachBuyerReqItem.buyerRateContractId,
                    companyERPCode: eachBuyerReqItem.companyERPCode,
                    brandId: relatedMaterial.brandId,
                    categoryId: relatedMaterial.categoryId,

                    isNew: true,
                    bQuotSellerListPrice: eachSellerReqItem.quotListPrice,
                    bQuotSellerGSTRate: eachSellerReqItem.quotGSTRate,
                    sellerLeadTime: eachSellerReqItem.quotLeadTime,
                    //hsnEnable: true,
                    gstOptions: [],
                    sellerQuoteQty: eachSellerReqItem.quotQty,
                    sellerUnitLogistics: eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0,
                    isSellerReqExpired: eachSellerReqItem.statusId === 2 ? true : false,
                    maxLogisticGSTRate: null
                }
                // newBuyerQuoteItem.sellerUnitPriceWithLogistics = newBuyerQuoteItem.bQuotSellerPrice + newBuyerQuoteItem.sellerUnitLogistics
                relatedBuyerQuoteItems.push(newBuyerQuoteItem)
            }

            relatedBuyerQuoteItems.sort((a, b) => b.bQuotSellerQty - a.bQuotSellerQty)

            let totalSellerTotalQty = 0
            relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                totalSellerTotalQty += eachBuyerQuoteItem.sellerQuoteQty
            })

            const maxBestSellerTotalQty = totalSellerTotalQty > eachBuyerReqItem.qty ? eachBuyerReqItem.qty : totalSellerTotalQty

            const bestSellerCombination = getBestSellerCombination(relatedBuyerQuoteItems, maxBestSellerTotalQty)

            relatedBuyerQuoteItems = relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                const relatedBestSellerQuote = bestSellerCombination.find(eachBestSellerQuote => eachBestSellerQuote.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
                if (relatedBestSellerQuote) {
                    eachBuyerQuoteItem.bestBQuotSellerQty = relatedBestSellerQuote.sellerQuoteQty
                }
                return eachBuyerQuoteItem
            })

            const selectedBuyerQuoteItems = relatedBuyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.bestBQuotSellerQty)

            const bestSellerWeightedSum = _.sumBy(selectedBuyerQuoteItems, obj => obj.bQuotSellerPrice * parseFloat(obj.bestBQuotSellerQty))
            const bestSellerTotalQuantity = _.sumBy(selectedBuyerQuoteItems, obj => parseFloat(obj.bestBQuotSellerQty))
            const bestSellerWeightedAverageSellerPrice = round(bestSellerWeightedSum / bestSellerTotalQuantity, 2)

            relatedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                eachBuyerQuoteItem.bestAvgSellerPrice = bestSellerWeightedAverageSellerPrice
            })

            allBuyerQuoteItems = [...allBuyerQuoteItems, ...relatedBuyerQuoteItems] 
        })
    })

    return allBuyerQuoteItems
}

export const getUploadedFileObj = async ({ files, options, documentName, allowedFileTypes }) => {
    let fileArr = []
    let error = false
    let errorMsg = ''
    await Promise.all(files.map(async (eachFile) => {
        if (eachFile.size > 5242880) {
            options.clear()
            error = true
            errorMsg = 'File size exceeds 5MB'
        }

        const { fileError, fileErrorMsg } = await checkFileType({file: eachFile, allowedFileTypes })
        if (fileError) {
            options.clear()
            error = fileError
            errorMsg = fileErrorMsg
        }

        if (!error) {
            const fileObj = await new Promise((resolve, reject) => {
                const fileReader = new FileReader()

                fileReader.onload = (e) => {
                    resolve({
                        documentName: documentName,
                        fileName: eachFile.name,
                        dataURI: e.target.result,
                        url: eachFile.objectURL,
                        file_name: eachFile.name,
                        name: eachFile.name,
                        data_uri: e.target.result,
                        objectURL: eachFile.objectURL,
                        inputName: options.props.name,
                        input_name: options.props.name
                    })
                }

                fileReader.readAsDataURL(eachFile)
            })
            fileArr.push(fileObj)
        }
    }))
    options.clear()
    return { fileArr, error, errorMsg }
}

export const checkFileType = async (data) => {
    const { file, allowedFileTypes } = data
    
    const fileType = await fileTypeFromBlob(file)
    
    const defaultAllowedMimeTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf']

    let allowedMimeTypes = [...defaultAllowedMimeTypes]
    if (allowedFileTypes && allowedFileTypes.length) {
        allowedMimeTypes = [...allowedFileTypes]
    }

    console.log("fileType", fileType)

    let error = false
    let errorMsg = ''
    if (!fileType || !allowedMimeTypes.includes(fileType.mime)) {
        error = true
        errorMsg = 'Invalid file type'
    }

    return {
        fileError: error,
        fileErrorMsg: errorMsg,
        error: error,
        errorMsg: errorMsg
    }
}

export const getBestSellerCombination = (sellerQuotes, totReqQty) => {
    sellerQuotes.sort((a, b) => a.sellerUnitPriceWithLogistics - b.sellerUnitPriceWithLogistics);

    let bestCombination = [];
    let remainingQty = totReqQty;

    for (let i = 0; i < sellerQuotes.length && remainingQty > 0; i++) {
        const seller = sellerQuotes[i];
        const qtyToUse = Math.min(remainingQty, seller.sellerQuoteQty);

        if (qtyToUse > 0) {
            bestCombination.push({
                sellerQuoteQty: qtyToUse,
                bQuotSellerPrice: seller.bQuotSellerPrice,
                sellerUnitPriceWithLogistics: seller.sellerUnitPriceWithLogistics,
                buyerQuoteItemId: seller.buyerQuoteItemId,
            });

            remainingQty -= qtyToUse;
        }
    }

    return bestCombination;
}

export const SACCodes = [
    995411,995412,995413,995414,995415,995416,995419,995421,995422,995423,995424,995425,995426,995427,995428,
    995429,995431,995432,995433,995434,995435,995439,995441,995442,995443,995444,995449,995451,995452,995453,
    995454,995455,995456,995457,995458,995459,995461,995462,995463,995464,995465,995466,995468,995469,995471,
    995472,995473,995474,995475,995476,995477,995478,995479,996111,996211,996311,996312,996313,996321,996322,
    996329,996331,996332,996333,996334,996335,996336,996337,996339,996411,996412,996413,996414,996415,996416,
    996419,996421,996422,996423,996424,996425,996426,996427,996429,996511,996512,996513,996519,996521,996522,
    996531,996532,996601,996602,996603,996609,996711,996712,996713,996719,996721,996722,996729,996731,996739,
    996741,996742,996743,996744,996749,996751,996752,996753,996759,996761,996762,996763,996764,996791,996792,
    996793,996799,996811,996812,996813,996819,996911,996912,996913,996921,996922,996929,997111,997112,997113,
    997114,997119,997120,997131,997132,997133,997134,997135,997136,997137,997139,997141,997142,997143,997144,
    997145,997146,997147,997149,997151,997152,997153,997154,997155,997156,997157,997158,997159,997161,997162,
    997163,997164,997169,997171,997172,997211,997212,997213,997214,997215,997221,997222,997223,997224,997311,
    997312,997313,997314,997315,997316,997319,997321,997322,997323,997324,997325,997326,997327,997329,997331,
    997332,997333,997334,997335,997336,997337,997338,997339,998111,998112,998113,998114,998121,998122,998130,
    998141,998142,998143,998144,998145,998211,998212,998213,998214,998215,998216,998221,998222,998223,998224,
    998231,998232,998240,998311,998312,998313,998314,998315,998316,998319,998321,998322,998323,998324,998325,
    998326,998327,998328,998331,998332,998333,998334,998335,998336,998337,998338,998339,998341,998342,998343,
    998344,998345,998346,998347,998348,998349,998351,998352,998359,998361,998362,998363,998364,998365,998366,
    998371,998372,998381,998382,998383,998384,998385,998386,998387,998391,998392,998393,998394,998395,998396,
    998397,998399,998411,998412,998413,998414,998415,998419,998421,998422,998423,998424,998429,998431,998432,
    998433,998434,998439,998441,998442,998443,998451,998452,998453,998461,998462,998463,998464,998465,998466,
    998511,998512,998513,998514,998515,998516,998517,998519,998521,998522,998523,998524,998525,998526,998527,
    998528,998529,998531,998532,998533,998534,998535,998536,998537,998538,998539,998540,998541,998542,998549,
    998551,998552,998553,998554,998555,998556,998557,998559,998591,998592,998593,998594,998595,998596,998597,
    998598,998599,998611,998612,998613,998614,998615,998619,998621,998622,998631,998632,998633,998634,998711,
    998712,998713,998714,998715,998716,998717,998718,998719,998721,998722,998723,998724,998725,998726,998727,
    998729,998731,998732,998733,998734,998735,998736,998739,998811,998812,998813,998814,998815,998816,998817,
    998818,998819,998821,998822,998823,998831,998832,998841,998842,998843,998851,998852,998853,998860,998871,
    998872,998873,998874,998875,998876,998877,998881,998882,998891,998892,998893,998894,998895,998896,998897,
    998898,998911,998912,998920,998931,998932,998933,998941,998942,999111,999112,999113,999119,999121,999122,
    999123,999124,999125,999126,999127,999128,999129,999131,999132,999133,999134,999210,999220,999231,999232,
    999241,999242,999243,999249,999259,999291,999292,999293,999294,999295,999299,999311,999312,999313,999314,
    999315,999316,999317,999319,999321,999322,999331,999332,999333,999334,999341,999349,999351,999352,999353,
    999359,999411,999412,999421,999422,999423,999424,999431,999432,999433,999441,999442,999443,999449,999451,
    999459,999490,999511,999512,999520,999591,999592,999593,999594,999595,999596,999597,999598,999599,999611,
    999612,999613,999614,999615,999621,999622,999623,999629,999631,999632,999633,999641,999642,999651,999652,
    999659,999661,999662,999691,999692,999693,999694,999699,999711,999712,999713,999714,999715,999719,999721,
    999722,999723,999729,999731,999732,999791,999792,999793,999794,999795,999799,999800,999900
]

export const getMinAndMaxDateRange = (dates) => {
    let minDate = null
    let maxDate = null

    if (dates.length > 0) {
        minDate = new Date(Math.min(...dates))
        maxDate = new Date(Math.max(...dates))
    }

    return { minDate, maxDate }
}

export const getColorFromName = (name) => {
    let hash = 0
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }

    const hue = Math.abs(hash % 360)
    const saturation = 70 + (Math.abs(hash) % 10)
    const lightness = 45 + (Math.abs(hash) % 10)

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}

export const excelSerialToJSDate = (serial) => {
    const excelEpoch = new Date(1899, 11, 30); // Month 11 = December
    return new Date(excelEpoch.getTime() + serial * 86400000);
}

// export const excelSerialToJSDate = (serial) => {
//     const excelEpoch = new Date(1899, 12, 1) // Excel's base date (Dec 30, 1899)
//     return new Date(excelEpoch.getTime() + serial * 86400000) // Add days in milliseconds
// }


export const getFileTypeAndIcon = (fileUrl) => {
    const fileTypeIcons = {
        pdf: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/pdf.png",
        xml: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/xml.png",
        doc: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/doc.png",
        docx: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/docx.png",
        xls: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/xsl.png",
        csv: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/csv.png",
        xlsx: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/xsl.png",
        txt: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/txt.png",
        jpg: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/jpg.png",
        jpeg: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/jpg.png",
        png: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/png.png",
        gif: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/gif.png",
        zip: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/zip.png",
        rar: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/rar.png",
        mp4: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/mp4.png",
        mp3: "https://procmart-tech.s3.ap-south-1.amazonaws.com/fileTypes/mp3.png"
    }

    const fileExtension = fileUrl.split('.').pop().toLowerCase()

    if (fileTypeIcons[fileExtension]) {
        return {
            type: fileExtension,
            icon: fileTypeIcons[fileExtension]
        }
    }

    return {
        type: "unknown",
        icon: "icons/default-icon.png"
    }
}

export const convertURLToDataURI = async (url) => {
    try {
        const response = await fetch(url)
        const blob = await response.blob()
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
        })
    } catch (error) {
        console.log("error-convertURLToDataURI", error)
    }
}

export const logisticHSNOptions = [
    {label: '996511', value: 996511},
    {label: '996512', value: 996512},
    {label: '996513', value: 996513},
    {label: '996519', value: 996519},
    {label: '996521', value: 996521},
    {label: '996522', value: 996522},
    {label: '996531', value: 996531},
    {label: '996532', value: 996532}
]

export const getGRNProcessingStatus = (data) => {
    const { sellerPIPunchItems, sellerGRNQCPunches } = data

    let isSellerPIPunchProcessed = sellerPIPunchItems.every(eachSellerPIPunchItem => {
        const relatedSellerGRNQCPunches = sellerGRNQCPunches.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchItemId === eachSellerPIPunchItem.sellerPIPunchItemId)
        relatedSellerGRNQCPunches.sort((a, b) => b.sellerGRNQCPunchId - a.sellerGRNQCPunchId)

        let latestSellerGRNQCPunch = null
        if (relatedSellerGRNQCPunches.length) {
            latestSellerGRNQCPunch = relatedSellerGRNQCPunches[0]
        }

        if (latestSellerGRNQCPunch) {
            if (parseFloat(latestSellerGRNQCPunch.acceptedQuantity) + parseFloat(latestSellerGRNQCPunch.rejectedQuantity) + parseFloat(latestSellerGRNQCPunch.shortQuantity) === parseFloat(eachSellerPIPunchItem.qty)) {
                return true
            }
        }
        return false
    })

    return isSellerPIPunchProcessed
}

export const getSellerPOPaymentTermChangeStatus = (sellerPO, masterPaymentTerms) => {
    
    let isSellerPOPaymentTermsChanged = false
    if(sellerPO.paymentTerms && masterPaymentTerms){
        Object.keys(sellerPO.paymentTerms).some(eachSellerPOPaymentTerm => {
            if(sellerPO.paymentTerms[eachSellerPOPaymentTerm] !== masterPaymentTerms[eachSellerPOPaymentTerm]){
                isSellerPOPaymentTermsChanged = true
            }
        })
    }
    
    let negativePaymentTermsExist = Object.keys(sellerPO.paymentTerms).some(eachPaymentTerm => {
        if (eachPaymentTerm === 'creditPeriodId') {
            const previousCreditPeriodId = masterPaymentTerms.creditPeriodId ? parseInt(masterPaymentTerms.creditPeriodId) : 0
            if (previousCreditPeriodId > parseInt(sellerPO.paymentTerms[eachPaymentTerm])) {
                return true
            }
        }
        else if (eachPaymentTerm !== "creditPeriodId" && sellerPO.paymentTerms[eachPaymentTerm] >= 0) {
            let paymentTermNames = ['payAdvPO', 'payAdvDelivery', 'payPDCDelivery', 'payOnDelivery', 'payCredit']

            let paymentTermShortName = eachPaymentTerm
            let previousValue = masterPaymentTerms[paymentTermShortName]

            let masterPaymentTermsPercentagesArr = []
            paymentTermNames.map(termName => {
                let percentage = masterPaymentTerms[termName]
                if (percentage) {
                    masterPaymentTermsPercentagesArr.push(percentage)
                } else {
                    masterPaymentTermsPercentagesArr.push(0)
                }
            })

            let availablePaymentPercentage = 0
            let previousTermExist = false

            let currentPaymentTermIndex = paymentTermNames.findIndex(term => {
                if (eachPaymentTerm === term) {
                    return true
                }
                return false
            })

            masterPaymentTermsPercentagesArr.map((termPercentage, index) => {
                if (index <= currentPaymentTermIndex) {
                    availablePaymentPercentage += termPercentage
                    availablePaymentPercentage = parseFloat(parseFloat(availablePaymentPercentage).toFixed(2))
                    if (index < currentPaymentTermIndex) {
                        previousTermExist = true
                    }
                }
            })

            if (eachPaymentTerm === 'payAdvPO') {
                if (parseFloat(sellerPO.paymentTerms[eachPaymentTerm]) > previousValue) {
                    return true
                }
            } else if (eachPaymentTerm === 'payAdvDelivery') {
                if (parseFloat(sellerPO.paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                    return true
                }
            } else if (eachPaymentTerm === 'payPDCDelivery') {
                if (parseFloat(sellerPO.paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                    return true
                }
            } else if (eachPaymentTerm === 'payOnDelivery') {
                if (parseFloat(sellerPO.paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                    return true
                }
            } else if (eachPaymentTerm === 'payCredit') {
                if (parseFloat(sellerPO.paymentTerms[eachPaymentTerm]) < previousValue) {
                    return true
                }
            }
        }
    })
    
    return {
        isSellerPOPaymentTermsChanged,
        negativePaymentTermsExist
    }
}

export const getAddFilterOptions = (searchConfig, searchOptions, searchParams, addFilterOption) => {
    const addFilterOptions = []
    searchConfig.map(eachConfig => {
        const optionExists = searchOptions.some(eachOption => {
            if (eachOption.srNO === eachConfig.srNO) {
                return true
            }
        })

        if (!optionExists && eachConfig.name !== searchParams["searchBy"]) {
            addFilterOptions.push({
                label: eachConfig.label,
                command: () => {
                    addFilterOption(eachConfig.srNO)
                }
            })
        }
    })

    return addFilterOptions
}

export const getSearchActiveStatus = (searchParams, searchConfig) => {
    const searchParamKeys = Object.keys(searchParams).filter(key => !["searchBy", "searchText", "dataType", "dateType"].includes(key) && searchParams[key])
    
    let isSearchActive = searchConfig.find(eachSearchConfig => {
        const isSearchOptionUsed = searchParamKeys.find(eachSearchParam => eachSearchParam === eachSearchConfig.name)
        return isSearchOptionUsed
    })
    if(searchParams.searchBy != "all" && searchParams.searchText !== ""){
        isSearchActive = true
    }
    if(searchParams.fromDate && searchParams.toDate){
        isSearchActive = true
    }

    return isSearchActive
}